// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const CategoryPage = () => {
//     const [categories, setCategories] = useState([]);
//     const [subcategories, setSubcategories] = useState([]);
//     const [selectedCategory, setSelectedCategory] = useState("");
//     const [categoryName, setCategoryName] = useState("");
//     const [subcategoryName, setSubcategoryName] = useState("");

//     // Pagination
//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 5;

//     useEffect(() => {
//         fetchCategories();
//     }, []);

//     const fetchCategories = async () => {
//         try {
//             const res = await axios.get("https://api.example.com/api/categories");
//             setCategories(res.data);
//         } catch (err) {
//             console.error("Error fetching categories:", err);
//         }
//     };

//     const fetchSubcategories = async (categoryId) => {
//         if (!categoryId) return;
//         try {
//             const res = await axios.get(
//                 `https://api.example.com/api/subcategories?categoryId=${categoryId}`
//             );
//             setSubcategories(res.data);
//         } catch (err) {
//             console.error("Error fetching subcategories:", err);
//         }
//     };

//     const handleAddCategory = async (e) => {
//         e.preventDefault();
//         if (!categoryName.trim()) return alert("Enter category name");
//         try {
//             await axios.post("https://api.example.com/api/categories", {
//                 name: categoryName,
//             });
//             setCategoryName("");
//             fetchCategories();
//         } catch (err) {
//             alert("Error adding category");
//             console.error(err);
//         }
//     };

//     const handleAddSubcategory = async (e) => {
//         e.preventDefault();
//         if (!selectedCategory || !subcategoryName.trim())
//             return alert("Select a category and enter subcategory name");
//         try {
//             await axios.post("https://api.example.com/api/subcategories", {
//                 categoryId: selectedCategory,
//                 name: subcategoryName,
//             });
//             setSubcategoryName("");
//             fetchSubcategories(selectedCategory);
//         } catch (err) {
//             alert("Error adding subcategory");
//             console.error(err);
//         }
//     };

//     // Pagination logic
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentItems = subcategories.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(subcategories.length / itemsPerPage);

//     return (
//         <div style={{ display: "flex", gap: "30px", padding: "20px", backgroundColor: "#f9fafb", minHeight: "90vh", }}>
//             {/* ==== LEFT: Form Section ==== */}
//             <div style={{ flex: "0 0 300px", backgroundColor: "#fff", padding: "20px", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", height: "fit-content", }}>
//                 <h3 style={{ marginBottom: "15px", color: "#2D3748" }}>Manage Categories</h3>

//                 {/* Add Category */}
//                 <form onSubmit={handleAddCategory} style={{ marginBottom: "25px" }}>
//                     <input type="text" placeholder="New Category Name" value={categoryName} onChange={(e) => setCategoryName(e.target.value)} style={{ width: "100%", padding: "8px", marginBottom: "10px", border: "1px solid #CBD5E0", borderRadius: "4px", }} />
//                     <button type="submit" style={{ width: "100%", padding: "8px", backgroundColor: "#3182CE", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer", }}>➕ Add Category</button>
//                 </form>

//                 {/* Add Subcategory */}
//                 <form onSubmit={handleAddSubcategory}>
//                     <select
//                         value={selectedCategory}
//                         onChange={(e) => {
//                             setSelectedCategory(e.target.value);
//                             fetchSubcategories(e.target.value);
//                         }}
//                         style={{ width: "100%", padding: "8px", marginBottom: "10px", border: "1px solid #CBD5E0", borderRadius: "4px", }}>
//                         <option value="">Select Category</option>
//                         {categories.map((cat) => (
//                             <option key={cat.id} value={cat.id}>
//                                 {cat.name}
//                             </option>
//                         ))}
//                     </select>

//                     <input type="text" placeholder="New Subcategory Name" value={subcategoryName} onChange={(e) => setSubcategoryName(e.target.value)} style={{ width: "100%", padding: "8px", marginBottom: "10px", border: "1px solid #CBD5E0", borderRadius: "4px", }} />

//                     <button type="submit" style={{ width: "100%", padding: "8px", backgroundColor: "#805AD5", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer", }}>➕ Add Subcategory</button>
//                 </form>
//             </div>

//             {/* ==== RIGHT: Table Section ==== */}
//             <div style={{ flex: 1, backgroundColor: "#fff", padding: "20px", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", }}>
//                 <h3 style={{ marginBottom: "15px", color: "#2D3748" }}>Subcategories</h3>
//                 <>
//                     <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px", }}>
//                         <thead style={{ backgroundColor: "#2D3748", color: "#fff" }}>
//                             <tr>
//                                 <th style={{ padding: "8px", border: "1px solid #ddd" }}>#</th>
//                                 <th style={{ padding: "8px", border: "1px solid #ddd" }}>Subcategory Name</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {currentItems.length > 0 ? (
//                                 currentItems.map((sub, idx) => (
//                                     <tr key={sub.id}>
//                                         <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", }}>{indexOfFirstItem + idx + 1}</td>
//                                         <td style={{ padding: "8px", border: "1px solid #ddd" }}>{sub.name}</td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="2" style={{ textAlign: "center", padding: "10px", border: "1px solid #ddd", color: "#888", }}>No subcategories found.</td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                     {/* Pagination */}
//                     {totalPages > 1 && (
//                         <div style={{ display: "flex", justifyContent: "center", marginTop: "15px", gap: "8px", }}>
//                             {[...Array(totalPages)].map((_, idx) => (
//                                 <button
//                                     key={idx}
//                                     onClick={() => setCurrentPage(idx + 1)}
//                                     style={{
//                                         padding: "6px 10px",
//                                         border:
//                                             currentPage === idx + 1
//                                                 ? "2px solid #3182CE"
//                                                 : "1px solid #CBD5E0",
//                                         backgroundColor:
//                                             currentPage === idx + 1 ? "#EBF8FF" : "#fff",
//                                         cursor: "pointer",
//                                         borderRadius: "4px",
//                                     }}
//                                 >
//                                     {idx + 1}
//                                 </button>
//                             ))}
//                         </div>
//                     )}
//                 </>

//             </div>
//         </div>
//     );
// };

// export default CategoryPage;

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { FaListUl, FaTags } from "react-icons/fa";

// const API = "https://cloudapi.emedhatechnologies.com/pages/api/api";

// const CategoryPage = () => {
//     const [categories, setCategories] = useState([]);
//     const [subcategories, setSubcategories] = useState([]);

//     const [selectedCategory, setSelectedCategory] = useState("");

//     const [categoryName, setCategoryName] = useState("");
//     const [subcategoryName, setSubcategoryName] = useState("");

//     const [editCategoryId, setEditCategoryId] = useState(null);
//     const [editSubcategoryId, setEditSubcategoryId] = useState(null);

//     const user = JSON.parse(sessionStorage.getItem("userData"));
//     const userId =user.type === "employee" ? user.parent_company_id : user.id;
// const currentUserId = user.id;
//     // pagination
//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 5;

//     useEffect(() => {
//         fetchCategories();
//     }, []);

// const fetchCategories = async () => {
//     const res = await axios.get(`${API}/categories?userId=${userId}`);
//     setCategories(res.data);
// };




// const fetchSubcategories = async (categoryId) => {
//     const res = await axios.get(`${API}/subcategories?categoryId=${categoryId}&userId=${userId}`);
//     setSubcategories(res.data);
// };

//     // ADD CATEGORY
//     const handleAddCategory = async (e) => {
//         e.preventDefault();
//         if (!categoryName.trim()) return;

//         await axios.post(`${API}/categories`, {
//             name: categoryName,
//             userId,
//             currentUserId
//         });

//         setCategoryName("");
//         fetchCategories();
//     };

//     // UPDATE CATEGORY
//     const handleUpdateCategory = async (e) => {
//         e.preventDefault();
//         await axios.put(`${API}/categories/${editCategoryId}`, {
//             name: categoryName,
//             currentUserId
//         });

//         setEditCategoryId(null);
//         setCategoryName("");
//         fetchCategories();
//     };

//     // DELETE CATEGORY
//     const deleteCategory = async (id) => {
//         if (window.confirm("Delete Category?")) {
//             await axios.delete(`${API}/categories/${id}`);
//             fetchCategories();
//         }
//     };

//     // ADD SUBCATEGORY
//     const handleAddSubcategory = async (e) => {
//         e.preventDefault();
//         if (!subcategoryName || !selectedCategory) return;

//         await axios.post(`${API}/subcategories`, {
//             categoryId: selectedCategory,
//             name: subcategoryName,
//             userId,
//              currentUserId,  
//         });

//         setSubcategoryName("");
//         fetchSubcategories(selectedCategory);
//     };

//     // UPDATE SUBCATEGORY
//     const handleUpdateSubcategory = async (e) => {
//         e.preventDefault();
//         await axios.put(`${API}/subcategories/${editSubcategoryId}`, {
//             name: subcategoryName,
//               categoryId: selectedCategory,
//                currentUserId,  
//         });

//         setEditSubcategoryId(null);
//         setSubcategoryName("");
//         fetchSubcategories(selectedCategory);
//     };




// // DELETE SUBCATEGORY  ← MUST BE HERE!
// const deleteSubcategory = async (id) => {
//     if (window.confirm("Delete Subcategory?")) {
//         await axios.delete(`${API}/subcategories/${id}`);
//         fetchSubcategories(selectedCategory);
//     }
// };


//     // PAGINATION
//     const indexOfLast = currentPage * itemsPerPage;
//     const indexOfFirst = indexOfLast - itemsPerPage;
//     const currentItems = subcategories.slice(indexOfFirst, indexOfLast);
//     const totalPages = Math.ceil(subcategories.length / itemsPerPage);

//     return (
//         <div style={{  backgroundColor: "#e4e5e6", minHeight: "90vh" }}>

//             {/* ================== CATEGORIES SECTION ================== */}
//             <div
//                 style={{

//                     padding: "10px",

//                     marginBottom: "30px",
//                     boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
//                 }}
//             >
//                 <h2 style={{ marginBottom: "15px", color: "#273179" }}>
//                 <FaTags/> Categories
//                 </h2>

//                 {/* CATEGORY FORM */}
//                 <form
//                     onSubmit={editCategoryId ? handleUpdateCategory : handleAddCategory}
//                     style={{ display: "flex", gap: "10px", marginBottom: "20px" }}
//                 >
//                     <input
//                         type="text"
//                         placeholder="Category name"
//                         value={categoryName}
//                         onChange={(e) => setCategoryName(e.target.value)}
//                         style={{
//                             flex: 1,
//                             padding: "10px",
//                             borderRadius: "6px",
//                             border: "1px solid #ccc",
//                         }}
//                     />

//                     <button
//                         type="submit"
//                         style={{
//                             padding: "10px 16px",
//                             background: editCategoryId ? "#E53E3E" : "#3182CE",
//                             color: "white",
//                             border: "none",
//                             borderRadius: "6px",
//                             cursor: "pointer",
//                         }}
//                     >
//                         {editCategoryId ? "Update" : "Add"}
//                     </button>
//                 </form>

//                 {/* CATEGORY TABLE */}
//                 <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                     <thead style={{ background: "#2D3748", color: "white" }}>
//                         <tr>
//                             <th style={{ padding: "10px", border: "1px solid #ccc" }}>#</th>
//                             <th style={{ padding: "10px", border: "1px solid #ccc" }}>Name</th>
//                             <th style={{ padding: "10px", border: "1px solid #ccc" }}>Actions</th>
//                         </tr>
//                     </thead>

//                     <tbody>
//                         {categories.map((cat, index) => (
//                             <tr key={cat.id}>
//                                 <td style={{ padding: "10px", border: "1px solid #ccc" }}>
//                                     {index + 1}
//                                 </td>
//                                 <td style={{ padding: "10px", border: "1px solid #ccc" }}>
//                                     {cat.name}
//                                 </td>
//                                 <td
//                                     style={{
//                                         padding: "10px",
//                                         border: "1px solid #ccc",
//                                         textAlign: "center",
//                                     }}
//                                 >
//                                     <button
//                                         onClick={() => {
//                                             setEditCategoryId(cat.id);
//                                             setCategoryName(cat.name);
//                                         }}
//                                         style={{
//                                             padding: "5px 10px",
//                                             background: "#3182CE",
//                                             color: "#fff",
//                                             border: "none",
//                                             borderRadius: "4px",
//                                             marginRight: "8px",
//                                             cursor: "pointer",
//                                         }}
//                                     >
//                                         Edit
//                                     </button>

//                                     <button
//                                         onClick={() => deleteCategory(cat.id)}
//                                         style={{
//                                             padding: "5px 10px",
//                                             background: "gray",
//                                             color: "#fff",
//                                             border: "none",
//                                             borderRadius: "4px",
//                                             cursor: "not-allowed",
//                                         }}
//                                             disabled
//                                     >

//                                         Delete
//                                     </button>
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>

//             {/* ================== SUBCATEGORIES SECTION ================== */}
//             <div
//                 style={{
//                     background: "#fff",
//                     padding: "0px",

//                     boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
//                 }}
//             >
//                 <h2 style={{ marginBottom: "15px", color: "#273179" }}>
//                    <FaListUl/> Subcategories
//                 </h2>

//                 {/* SUBCATEGORY FORM */}
//                 <form
//                     onSubmit={
//                         editSubcategoryId ? handleUpdateSubcategory : handleAddSubcategory
//                     }
//                     style={{ display: "flex", gap: "10px", marginBottom: "20px" }}
//                 >
//                     <select
//                         value={selectedCategory}
//                         onChange={(e) => {
//                             setSelectedCategory(e.target.value);
//                             fetchSubcategories(e.target.value);
//                         }}
//                         style={{
//                             flex: 1,
//                             padding: "10px",
//                             borderRadius: "6px",
//                             border: "1px solid #ccc",
//                         }}
//                     >
//                         <option value="">Select Category</option>
//                         {categories.map((cat) => (
//                             <option key={cat.id} value={cat.id}>
//                                 {cat.name}
//                             </option>
//                         ))}
//                     </select>

//                     <input
//                         type="text"
//                         placeholder="Subcategory Name"
//                         value={subcategoryName}
//                         onChange={(e) => setSubcategoryName(e.target.value)}
//                         style={{
//                             flex: 1,
//                             padding: "10px",
//                             borderRadius: "6px",
//                             border: "1px solid #ccc",
//                         }}
//                     />

//                     <button
//                         type="submit"
//                         style={{
//                             padding: "10px 16px",
//                             background: editSubcategoryId ? "#805AD5" : "#3182CE",
//                             color: "white",
//                             border: "none",
//                             borderRadius: "6px",
//                             cursor: "pointer",
//                         }}
//                     >
//                         {editSubcategoryId ? "Update" : "Add"}
//                     </button>
//                 </form>

//                 {/* SUBCATEGORY TABLE */}
//                 <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                     <thead style={{ background: "#2D3748", color: "white" }}>
//                         <tr>
//                             <th style={{ padding: "10px", border: "1px solid #ccc" }}>#</th>
//                             <th style={{ padding: "10px", border: "1px solid #ccc" }}>Name</th>
//                             <th style={{ padding: "10px", border: "1px solid #ccc" }}>Actions</th>
//                         </tr>
//                     </thead>

//                     <tbody>
//                         {currentItems.map((sub, index) => (
//                             <tr key={sub.id}>
//                                 <td style={{ padding: "10px", border: "1px solid #ccc" }}>
//                                     {indexOfFirst + index + 1}
//                                 </td>

//                                 <td style={{ padding: "10px", border: "1px solid #ccc" }}>
//                                     {sub.name}
//                                 </td>

//                                 <td
//                                     style={{
//                                         padding: "10px",
//                                         border: "1px solid #ccc",
//                                         textAlign: "center",
//                                     }}
//                                 >
//                                     <button
//                                         onClick={() => {
//                                             setEditSubcategoryId(sub.id);
//                                             setSubcategoryName(sub.name);
//                                             setSelectedCategory(sub.category_id); 
//                                         }}
//                                         style={{
//                                             padding: "5px 10px",
//                                             background: "#3182CE",
//                                             color: "#fff",
//                                             border: "none",
//                                             borderRadius: "4px",
//                                             marginRight: "8px",
//                                             cursor: "pointer",
//                                         }}
//                                     >
//                                         Edit
//                                     </button>

//                                     <button
//                                         onClick={() => deleteSubcategory(sub.id)}
//                                         style={{
//                                             padding: "5px 10px",
//                                             background: "gray",
//                                             color: "#fff",
//                                             border: "none",
//                                             borderRadius: "4px",
//                                             cursor: "not-allowed",

//                                         }}
//                                         disabled
//                                     >
//                                         Delete
//                                     </button>
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>

//                 {/* PAGINATION */}
//                 {totalPages > 1 && (
//                     <div
//                         style={{
//                             display: "flex",
//                             justifyContent: "center",
//                             marginTop: "15px",
//                             gap: "6px",
//                         }}
//                     >
//                         {[...Array(totalPages)].map((_, idx) => (
//                             <button
//                                 key={idx}
//                                 onClick={() => setCurrentPage(idx + 1)}
//                                 style={{
//                                     padding: "6px 10px",
//                                     background: currentPage === idx + 1 ? "#3182CE" : "#fff",
//                                     border: "1px solid #ccc",
//                                     borderRadius: "4px",
//                                     cursor: "pointer",
//                                     color: currentPage === idx + 1 ? "white" : "black",
//                                 }}
//                             >
//                                 {idx + 1}
//                             </button>
//                         ))}
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default CategoryPage;










// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { FaEdit, FaListUl, FaPencilAlt, FaPlus, FaTags, FaTrash } from "react-icons/fa";

// const API = "https://cloudapi.emedhatechnologies.com/pages/api/api";

// const CategoryPage = () => {
//     const [categories, setCategories] = useState([]);
//     const [subcategories, setSubcategories] = useState([]);

//     const [selectedCategory, setSelectedCategory] = useState("");

//     const [categoryName, setCategoryName] = useState("");
//     const [subcategoryName, setSubcategoryName] = useState("");

//     const [editCategoryId, setEditCategoryId] = useState(null);
//     const [editSubcategoryId, setEditSubcategoryId] = useState(null);

//     const user = JSON.parse(sessionStorage.getItem("userData"));
//     const userId = user.type === "employee" ? user.parent_company_id : user.id;
//     const currentUserId = user.id;
//     // pagination
//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 5;

//     useEffect(() => {
//         fetchCategories();
//     }, []);

//     const fetchCategories = async () => {
//         const res = await axios.get(`${API}/categories?userId=${userId}`);
//         setCategories(res.data);
//     };




//     const fetchSubcategories = async (categoryId) => {
//         const res = await axios.get(`${API}/subcategories?categoryId=${categoryId}&userId=${userId}`);
//         setSubcategories(res.data);
//     };

//     // ADD CATEGORY
//     const handleAddCategory = async (e) => {
//         e.preventDefault();
//         if (!categoryName.trim()) return;

//         await axios.post(`${API}/categories`, {
//             name: categoryName,
//             userId,
//             currentUserId
//         });

//         setCategoryName("");
//         fetchCategories();
//     };

//     // UPDATE CATEGORY
//     const handleUpdateCategory = async (e) => {
//         e.preventDefault();
//         await axios.put(`${API}/categories/${editCategoryId}`, {
//             name: categoryName,
//             currentUserId
//         });

//         setEditCategoryId(null);
//         setCategoryName("");
//         fetchCategories();
//     };

//     // DELETE CATEGORY
//     const deleteCategory = async (id) => {
//         if (window.confirm("Delete Category?")) {
//             await axios.delete(`${API}/categories/${id}`);
//             fetchCategories();
//         }
//     };

//     // ADD SUBCATEGORY
//     const handleAddSubcategory = async (e) => {
//         e.preventDefault();
//         if (!subcategoryName || !selectedCategory) return;

//         await axios.post(`${API}/subcategories`, {
//             categoryId: selectedCategory,
//             name: subcategoryName,
//             userId,
//             currentUserId,
//         });

//         setSubcategoryName("");
//         fetchSubcategories(selectedCategory);
//     };

//     // UPDATE SUBCATEGORY
//     const handleUpdateSubcategory = async (e) => {
//         e.preventDefault();
//         await axios.put(`${API}/subcategories/${editSubcategoryId}`, {
//             name: subcategoryName,
//             categoryId: selectedCategory,
//             currentUserId,
//         });

//         setEditSubcategoryId(null);
//         setSubcategoryName("");
//         fetchSubcategories(selectedCategory);
//     };




//     // DELETE SUBCATEGORY  ← MUST BE HERE!
//     const deleteSubcategory = async (id) => {
//         if (window.confirm("Delete Subcategory?")) {
//             await axios.delete(`${API}/subcategories/${id}`);
//             fetchSubcategories(selectedCategory);
//         }
//     };


//     // PAGINATION
//     const indexOfLast = currentPage * itemsPerPage;
//     const indexOfFirst = indexOfLast - itemsPerPage;
//     const currentItems = subcategories.slice(indexOfFirst, indexOfLast);
//     const totalPages = Math.ceil(subcategories.length / itemsPerPage);

//     return (

//         <div style={{ minHeight: "90vh" }}>

//             {/* <div style={{ backgroundColor: "#e4e5e6", minHeight: "90vh" }}>
//                 <div style={{ padding: "10px", marginBottom: "30px", boxShadow: "0 2px 10px rgba(0,0,0,0.08)", }}>
//                     <h2 style={{ marginBottom: "15px", color: "#273179" }}><FaTags /> Categories</h2>
//                     <form onSubmit={editCategoryId ? handleUpdateCategory : handleAddCategory} style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "20px" }}>
//                         <input type="text" placeholder="Category name" value={categoryName} onChange={(e) => setCategoryName(e.target.value)} style={{ flex: 1, minWidth: "200px", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }} />
//                         <button type="submit" style={{ padding: "10px 16px", minWidth: "120px", background: editCategoryId ? "#E53E3E" : "#3182CE", color: "white", border: "none", borderRadius: "6px", cursor: "pointer" }}>
//                             {editCategoryId ? "Update" : "Add"}
//                         </button>
//                     </form>
//                     <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                         <thead style={{ background: "#2D3748", color: "white" }}>
//                             <tr>
//                                 <th style={{ padding: "10px", border: "1px solid #ccc" }}>#</th>
//                                 <th style={{ padding: "10px", border: "1px solid #ccc" }}>Name</th>
//                                 <th style={{ padding: "10px", border: "1px solid #ccc" }}>Actions</th>
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {categories.map((cat, index) => (
//                                 <tr key={cat.id}>
//                                     <td style={{ padding: "10px", border: "1px solid #ccc" }}>{index + 1}</td>
//                                     <td style={{ padding: "10px", border: "1px solid #ccc" }}>{cat.name}</td>
//                                     <td style={{ padding: "10px", border: "1px solid #ccc", textAlign: "center", }}>
//                                         <button onClick={() => { setEditCategoryId(cat.id); setCategoryName(cat.name); }} style={{ padding: "5px 10px", background: "#3182CE", color: "#fff", border: "none", borderRadius: "4px", marginRight: "8px", cursor: "pointer", }}>Edit</button>
//                                         <button onClick={() => deleteCategory(cat.id)} style={{ padding: "5px 10px", background: "gray", color: "#fff", border: "none", borderRadius: "4px", cursor: "not-allowed", }} disabled>Delete</button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div> */}


//             <div style={{ backgroundColor: "#e4e5e6", minHeight: "90vh",  }}>
//                 {/* ================== CATEGORIES SECTION ================== */}
//                 <div style={{ padding: "15px", marginBottom: "30px", boxShadow: "0 2px 10px rgba(0,0,0,0.08)", borderRadius: "8px", backgroundColor: "#fff" }}>
//                     <h2 style={{ marginBottom: "15px", color: "#273179", display: "flex", alignItems: "center", gap: "8px" }}>
//                         <FaTags /> Categories
//                     </h2>

//                     {/* CATEGORY FORM */}
//                     <form
//                         onSubmit={editCategoryId ? handleUpdateCategory : handleAddCategory}
//                         style={{
//                             display: "flex",
//                             flexWrap: "wrap",
//                             gap: "10px",
//                             marginBottom: "20px",
//                         }}
//                     >
//                         <input
//                             type="text"
//                             placeholder="Category name"
//                             value={categoryName}
//                             onChange={(e) => setCategoryName(e.target.value)}
//                             style={{
//                                 flex: "1 1 200px",
//                                 padding: "10px",
//                                 borderRadius: "6px",
//                                 border: "1px solid #ccc",
//                                 fontSize: "14px",
//                             }}
//                         />

//                         <button
//                             type="submit"
//                             style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 gap: "6px",
//                                 padding: "10px",
//                                 minWidth: "50px",
//                                 background: editCategoryId ? "#E53E3E" : "#3182CE",
//                                 color: "#fff",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                             }}
//                         >
//                             {editCategoryId ? <FaPencilAlt /> : <FaPlus />}
//                         </button>
//                     </form>

//                     {/* CATEGORY LIST (cards on mobile) */}
//                     <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//                         {categories.map((cat, index) => (
//                             <div
//                                 key={cat.id}
//                                 style={{
//                                     display: "flex",
//                                     justifyContent: "space-between",
//                                     alignItems: "center",
//                                     flexWrap: "wrap",
//                                     padding: "12px",
//                                     borderRadius: "8px",
//                                     border: "1px solid #ccc",
//                                     backgroundColor: "#fefefe",
//                                 }}
//                             >
//                                 <div style={{ fontWeight: 500 }}>{index + 1}. {cat.name}</div>

//                                 <div style={{ display: "flex", gap: "8px", marginTop: "5px" }}>
//                                     <button
//                                         onClick={() => { setEditCategoryId(cat.id); setCategoryName(cat.name); }}
//                                         style={{
//                                             display: "flex",
//                                             alignItems: "center",
//                                             justifyContent: "center",
//                                             padding: "6px",
//                                             background: "#3182CE",
//                                             color: "#fff",
//                                             border: "none",
//                                             borderRadius: "4px",
//                                             cursor: "pointer",
//                                         }}
//                                     >
//                                         <FaPencilAlt />
//                                     </button>

//                                     <button
//                                         onClick={() => deleteCategory(cat.id)}
//                                         style={{
//                                             display: "flex",
//                                             alignItems: "center",
//                                             justifyContent: "center",
//                                             padding: "6px",
//                                             background: "#E53E3E",
//                                             color: "#fff",
//                                             border: "none",
//                                             borderRadius: "4px",
//                                             cursor: "pointer",
//                                         }}
//                                     >
//                                         <FaTrash />
//                                     </button>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>


//             {/* <div style={{ backgroundColor: "#e4e5e6", minHeight: "90vh" }}>
//                 <div style={{ background: "#e4e5e6", padding: "10px", boxShadow: "0 2px 10px rgba(0,0,0,0.08)", }}>
//                     <h2 style={{ marginBottom: "15px", color: "#273179" }}><FaListUl /> Subcategories</h2>
//                     <form onSubmit={editSubcategoryId ? handleUpdateSubcategory : handleAddSubcategory} style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "20px" }}>
//                         <select
//                             value={selectedCategory}
//                             onChange={(e) => {
//                                 setSelectedCategory(e.target.value);
//                                 fetchSubcategories(e.target.value);
//                             }}
//                             style={{ flex: 1, minWidth: "150px", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}>
//                             <option value="">Select Category</option>
//                             {categories.map((cat) => (
//                                 <option key={cat.id} value={cat.id}>{cat.name}</option>
//                             ))}
//                         </select>

//                         <input type="text" placeholder="Subcategory Name" value={subcategoryName} onChange={(e) => setSubcategoryName(e.target.value)} style={{ flex: 1, minWidth: "150px", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }} />
//                         <button type="submit" style={{ padding: "10px 16px", minWidth: "120px", background: editSubcategoryId ? "#805AD5" : "#3182CE", color: "white", border: "none", borderRadius: "6px", cursor: "pointer" }}>{editSubcategoryId ? "Update" : "Add"}</button>
//                     </form>
//                     <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                         <thead style={{ background: "#2D3748", color: "white" }}>
//                             <tr>
//                                 <th style={{ padding: "10px", border: "1px solid #ccc" }}>#</th>
//                                 <th style={{ padding: "10px", border: "1px solid #ccc" }}>Name</th>
//                                 <th style={{ padding: "10px", border: "1px solid #ccc" }}>Actions</th>
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {currentItems.map((sub, index) => (
//                                 <tr key={sub.id}>
//                                     <td style={{ padding: "10px", border: "1px solid #ccc" }}>{indexOfFirst + index + 1}</td>
//                                     <td style={{ padding: "10px", border: "1px solid #ccc" }}>{sub.name}</td>

//                                     <td style={{ padding: "10px", border: "1px solid #ccc", textAlign: "center", }}>
//                                         <button
//                                             onClick={() => {
//                                                 setEditSubcategoryId(sub.id);
//                                                 setSubcategoryName(sub.name);
//                                                 setSelectedCategory(sub.category_id);
//                                             }}
//                                             style={{
//                                                 padding: "5px 10px",
//                                                 background: "#3182CE",
//                                                 color: "#fff",
//                                                 border: "none",
//                                                 borderRadius: "4px",
//                                                 marginRight: "8px",
//                                                 cursor: "pointer",
//                                             }}
//                                         >
//                                             Edit
//                                         </button>

//                                         <button
//                                             onClick={() => deleteSubcategory(sub.id)}
//                                             style={{
//                                                 padding: "5px 10px",
//                                                 background: "gray",
//                                                 color: "#fff",
//                                                 border: "none",
//                                                 borderRadius: "4px",
//                                                 cursor: "not-allowed",

//                                             }}
//                                             disabled
//                                         >
//                                             Delete
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>


//                     {totalPages > 1 && (
//                         <div
//                             style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 marginTop: "15px",
//                                 gap: "6px",
//                             }}
//                         >
//                             {[...Array(totalPages)].map((_, idx) => (
//                                 <button
//                                     key={idx}
//                                     onClick={() => setCurrentPage(idx + 1)}
//                                     style={{
//                                         padding: "6px 10px",
//                                         background: currentPage === idx + 1 ? "#3182CE" : "#fff",
//                                         border: "1px solid #ccc",
//                                         borderRadius: "4px",
//                                         cursor: "pointer",
//                                         color: currentPage === idx + 1 ? "white" : "black",
//                                     }}
//                                 >
//                                     {idx + 1}
//                                 </button>
//                             ))}
//                         </div>
//                     )}
//                 </div>
//             </div> */}

//             <div style={{  minHeight: "90vh", padding: "10px" }}>
//                 {/* ================== SUBCATEGORIES SECTION ================== */}
//                 <div style={{ boxShadow: "0 2px 10px rgba(0,0,0,0.08)", borderRadius: "8px", backgroundColor: "#fff" }}>
//                     <h2 style={{ marginBottom: "15px", color: "#273179", display: "flex", alignItems: "center", gap: "8px" }}>
//                         <FaListUl /> Subcategories
//                     </h2>

//                     {/* SUBCATEGORY FORM */}
//                     <form
//                         onSubmit={editSubcategoryId ? handleUpdateSubcategory : handleAddSubcategory}
//                         style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "20px" }}
//                     >
//                         <select
//                             value={selectedCategory}
//                             onChange={(e) => {
//                                 setSelectedCategory(e.target.value);
//                                 fetchSubcategories(e.target.value);
//                             }}
//                             style={{
//                                 flex: "1 1 150px",
//                                 padding: "10px",
//                                 borderRadius: "6px",
//                                 border: "1px solid #ccc",
//                             }}
//                         >
//                             <option value="">Select Category</option>
//                             {categories.map((cat) => (
//                                 <option key={cat.id} value={cat.id}>{cat.name}</option>
//                             ))}
//                         </select>

//                         <input
//                             type="text"
//                             placeholder="Subcategory Name"
//                             value={subcategoryName}
//                             onChange={(e) => setSubcategoryName(e.target.value)}
//                             style={{
//                                 flex: "1 1 150px",
//                                 padding: "10px",
//                                 borderRadius: "6px",
//                                 border: "1px solid #ccc",
//                             }}
//                         />

//                         <button
//                             type="submit"
//                             style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 gap: "6px",
//                                 padding: "10px",
//                                 minWidth: "50px",
//                                 background: editSubcategoryId ? "#805AD5" : "#3182CE",
//                                 color: "#fff",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                             }}
//                         >
//                             <FaPlus />
//                         </button>
//                     </form>

//                     {/* SUBCATEGORY LIST (cards for mobile) */}
//                     <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//                         {currentItems.map((sub, index) => (
//                             <div
//                                 key={sub.id}
//                                 style={{
//                                     display: "flex",
//                                     justifyContent: "space-between",
//                                     alignItems: "center",
//                                     flexWrap: "wrap",
//                                     padding: "12px",
//                                     borderRadius: "8px",
//                                     border: "1px solid #ccc",
//                                     backgroundColor: "#fefefe",
//                                 }}
//                             >
//                                 <div style={{ fontWeight: 500 }}>
//                                     {indexOfFirst + index + 1}. {sub.name}
//                                 </div>

//                                 <div style={{ display: "flex", gap: "8px", marginTop: "5px" }}>
//                                     <button
//                                         onClick={() => {
//                                             setEditSubcategoryId(sub.id);
//                                             setSubcategoryName(sub.name);
//                                             setSelectedCategory(sub.category_id);
//                                         }}
//                                         style={{
//                                             display: "flex",
//                                             alignItems: "center",
//                                             justifyContent: "center",
//                                             padding: "6px",
//                                             background: "#3182CE",
//                                             color: "#fff",
//                                             border: "none",
//                                             borderRadius: "4px",
//                                             cursor: "pointer",
//                                         }}
//                                     >
//                                         <FaPencilAlt />
//                                     </button>

//                                     <button
//                                         onClick={() => deleteSubcategory(sub.id)}
//                                         style={{
//                                             display: "flex",
//                                             alignItems: "center",
//                                             justifyContent: "center",
//                                             padding: "6px",
//                                             background: "#E53E3E",
//                                             color: "#fff",
//                                             border: "none",
//                                             borderRadius: "4px",
//                                             cursor: "pointer",
//                                         }}
//                                     >
//                                         <FaTrash />
//                                     </button>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>

//                     {/* PAGINATION */}
//                     {totalPages > 1 && (
//                         <div
//                             style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 marginTop: "15px",
//                                 gap: "6px",
//                                 flexWrap: "wrap",
//                             }}
//                         >
//                             {[...Array(totalPages)].map((_, idx) => (
//                                 <button
//                                     key={idx}
//                                     onClick={() => setCurrentPage(idx + 1)}
//                                     style={{
//                                         padding: "6px 10px",
//                                         background: currentPage === idx + 1 ? "#3182CE" : "#fff",
//                                         border: "1px solid #ccc",
//                                         borderRadius: "4px",
//                                         cursor: "pointer",
//                                         color: currentPage === idx + 1 ? "white" : "black",
//                                     }}
//                                 >
//                                     {idx + 1}
//                                 </button>
//                             ))}
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default CategoryPage;


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { FaListUl, FaPencilAlt, FaPlus, FaTags, FaTrash } from "react-icons/fa";

// const API = "https://cloudapi.emedhatechnologies.com/pages/api/api";

// const CategoryPage = () => {
//   const [categories, setCategories] = useState([]);
//   const [subcategories, setSubcategories] = useState([]);

//   const [selectedCategory, setSelectedCategory] = useState("");

//   const [categoryName, setCategoryName] = useState("");
//   const [subcategoryName, setSubcategoryName] = useState("");

//   const [editCategoryId, setEditCategoryId] = useState(null);
//   const [editSubcategoryId, setEditSubcategoryId] = useState(null);

//   const user = JSON.parse(sessionStorage.getItem("userData"));
//   const userId = user.type === "employee" ? user.parent_company_id : user.id;
//   const currentUserId = user.id;

//   // ✅ SEPARATE PAGINATION STATES
//   const [categoryPage, setCategoryPage] = useState(1);
//   const [subPage, setSubPage] = useState(1);

//   const ITEMS_PER_PAGE = 5;

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   const fetchCategories = async () => {
//     const res = await axios.get(`${API}/categories?userId=${userId}`);
//     setCategories(res.data);
//   };

//   const fetchSubcategories = async (categoryId) => {
//     const res = await axios.get(
//       `${API}/subcategories?categoryId=${categoryId}&userId=${userId}`
//     );
//     setSubcategories(res.data);
//   };

//   // ================= CATEGORY =================
//   const handleAddCategory = async (e) => {
//     e.preventDefault();
//     await axios.post(`${API}/categories`, {
//       name: categoryName,
//       userId,
//       currentUserId,
//     });
//     setCategoryName("");
//     fetchCategories();
//   };

//   const handleUpdateCategory = async (e) => {
//     e.preventDefault();
//     await axios.put(`${API}/categories/${editCategoryId}`, {
//       name: categoryName,
//       currentUserId,
//     });
//     setEditCategoryId(null);
//     setCategoryName("");
//     fetchCategories();
//   };

//   const deleteCategory = async (id) => {
//     if (window.confirm("Delete Category?")) {
//       await axios.delete(`${API}/categories/${id}`);
//       fetchCategories();
//     }
//   };

//   // ================= SUBCATEGORY =================
//   const handleAddSubcategory = async (e) => {
//     e.preventDefault();
//     await axios.post(`${API}/subcategories`, {
//       categoryId: selectedCategory,
//       name: subcategoryName,
//       userId,
//       currentUserId,
//     });
//     setSubcategoryName("");
//     fetchSubcategories(selectedCategory);
//   };

//   const handleUpdateSubcategory = async (e) => {
//     e.preventDefault();
//     await axios.put(`${API}/subcategories/${editSubcategoryId}`, {
//       name: subcategoryName,
//       categoryId: selectedCategory,
//       currentUserId,
//     });
//     setEditSubcategoryId(null);
//     setSubcategoryName("");
//     fetchSubcategories(selectedCategory);
//   };

//   const deleteSubcategory = async (id) => {
//     if (window.confirm("Delete Subcategory?")) {
//       await axios.delete(`${API}/subcategories/${id}`);
//       fetchSubcategories(selectedCategory);
//     }
//   };

//   // ================= PAGINATION =================
//   const categoryStart = (categoryPage - 1) * ITEMS_PER_PAGE;
//   const categoryEnd = categoryStart + ITEMS_PER_PAGE;
//   const paginatedCategories = categories.slice(categoryStart, categoryEnd);

//   const subStart = (subPage - 1) * ITEMS_PER_PAGE;
//   const subEnd = subStart + ITEMS_PER_PAGE;
//   const paginatedSubcategories = subcategories.slice(subStart, subEnd);

//   return (
//     <div style={{ minHeight: "100vh", background: "#e4e5e6", padding: "15px" }}>

//       {/* ================= SIDE BY SIDE ================= */}
//       <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>

//         {/* ================= CATEGORY ================= */}
//         <div style={{
//           flex: "1 1 420px",
//           background: "#fff",
//           padding: "15px",
//           borderRadius: "10px",
//           boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
//         }}>

//           <h3 style={{ display: "flex", gap: "8px", alignItems: "center" }}>
//             <FaTags /> Categories
//           </h3>

//           <form onSubmit={editCategoryId ? handleUpdateCategory : handleAddCategory}
//             style={{ display: "flex", gap: "8px", marginBottom: "10px" }}>

//             <input
//               value={categoryName}
//               onChange={(e) => setCategoryName(e.target.value)}
//               placeholder="Category"
//               style={{ flex: 1, padding: "8px" }}
//             />

//             <button style={{ background: "#3182CE", color: "#fff" }}>
//               <FaPlus />
//             </button>
//           </form>

//           {/* LIST */}
//           {paginatedCategories.map((cat, i) => (
//             <div key={cat.id} style={{
//               display: "flex",
//               justifyContent: "space-between",
//               padding: "8px",
//               border: "1px solid #ddd",
//               marginBottom: "6px",
//               borderRadius: "6px"
//             }}>
//               <span>{categoryStart + i + 1}. {cat.name}</span>

//               <div style={{ display: "flex", gap: "5px" }}>
//                 <button onClick={() => {
//                   setEditCategoryId(cat.id);
//                   setCategoryName(cat.name);
//                 }}>
//                   <FaPencilAlt />
//                 </button>

//                 <button onClick={() => deleteCategory(cat.id)}>
//                   <FaTrash />
//                 </button>
//               </div>
//             </div>
//           ))}

//           {/* PAGINATION */}
//           <div style={{ display: "flex", justifyContent: "flex-end", gap: "5px" }}>
//             {Array.from({ length: Math.ceil(categories.length / ITEMS_PER_PAGE) }).map((_, i) => (
//               <button
//                 key={i}
//                 onClick={() => setCategoryPage(i + 1)}
//                 style={{
//                   width: "26px",
//                   height: "26px",
//                   fontSize: "12px",
//                   background: categoryPage === i + 1 ? "#3182CE" : "#fff"
//                 }}
//               >
//                 {i + 1}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* ================= SUBCATEGORY ================= */}
//         <div style={{
//           flex: "1 1 420px",
//           background: "#fff",
//           padding: "15px",
//           borderRadius: "10px",
//           boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
//         }}>

//           <h3 style={{ display: "flex", gap: "8px", alignItems: "center" }}>
//             <FaListUl /> Subcategories
//           </h3>

//           <form onSubmit={editSubcategoryId ? handleUpdateSubcategory : handleAddSubcategory}
//             style={{ display: "flex", gap: "8px", marginBottom: "10px" }}>

//             <select
//               value={selectedCategory}
//               onChange={(e) => {
//                 setSelectedCategory(e.target.value);
//                 fetchSubcategories(e.target.value);
//                 setSubPage(1); // reset sub pagination
//               }}
//             >
//               <option>Select</option>
//               {categories.map(c => (
//                 <option key={c.id} value={c.id}>{c.name}</option>
//               ))}
//             </select>

//             <input
//               value={subcategoryName}
//               onChange={(e) => setSubcategoryName(e.target.value)}
//               placeholder="Subcategory"
//             />

//             <button>
//               <FaPlus />
//             </button>
//           </form>

//           {/* LIST */}
//           {paginatedSubcategories.map((sub, i) => (
//             <div key={sub.id} style={{
//               display: "flex",
//               justifyContent: "space-between",
//               padding: "8px",
//               border: "1px solid #ddd",
//               marginBottom: "6px",
//               borderRadius: "6px"
//             }}>
//               <span>{subStart + i + 1}. {sub.name}</span>

//               <div style={{ display: "flex", gap: "5px" }}>
//                 <button onClick={() => {
//                   setEditSubcategoryId(sub.id);
//                   setSubcategoryName(sub.name);
//                   setSelectedCategory(sub.category_id);
//                 }}>
//                   <FaPencilAlt />
//                 </button>

//                 <button onClick={() => deleteSubcategory(sub.id)}>
//                   <FaTrash />
//                 </button>
//               </div>
//             </div>
//           ))}

//           {/* PAGINATION */}
//           <div style={{ display: "flex", justifyContent: "flex-end", gap: "5px" }}>
//             {Array.from({ length: Math.ceil(subcategories.length / ITEMS_PER_PAGE) }).map((_, i) => (
//               <button
//                 key={i}
//                 onClick={() => setSubPage(i + 1)}
//                 style={{
//                   width: "26px",
//                   height: "26px",
//                   fontSize: "12px",
//                   background: subPage === i + 1 ? "#3182CE" : "#fff"
//                 }}
//               >
//                 {i + 1}
//               </button>
//             ))}
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default CategoryPage;


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { FaListUl, FaPencilAlt, FaPlus, FaTags, FaTrash } from "react-icons/fa";

// const API = "https://cloudapi.emedhatechnologies.com/pages/api/api";

// const CategoryPage = () => {
//   const [categories, setCategories] = useState([]);
//   const [subcategories, setSubcategories] = useState([]);

//   const [selectedCategory, setSelectedCategory] = useState("");

//   const [categoryName, setCategoryName] = useState("");
//   const [subcategoryName, setSubcategoryName] = useState("");

//   const [editCategoryId, setEditCategoryId] = useState(null);
//   const [editSubcategoryId, setEditSubcategoryId] = useState(null);

//   const user = JSON.parse(sessionStorage.getItem("userData"));
//   const userId = user.type === "employee" ? user.parent_company_id : user.id;
//   const currentUserId = user.id;

//   const [categoryPage, setCategoryPage] = useState(1);
//   const [subPage, setSubPage] = useState(1);

//   const ITEMS_PER_PAGE = 8;

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   const fetchCategories = async () => {
//     const res = await axios.get(`${API}/categories?userId=${userId}`);
//     setCategories(res.data);
//   };

//   const fetchSubcategories = async (categoryId) => {
//     const res = await axios.get(
//       `${API}/subcategories?categoryId=${categoryId}&userId=${userId}`
//     );
//     setSubcategories(res.data);
//   };

//   // ================= CATEGORY =================
//   const handleAddCategory = async (e) => {
//     e.preventDefault();
//     await axios.post(`${API}/categories`, {
//       name: categoryName,
//       userId,
//       currentUserId,
//     });
//     setCategoryName("");
//     fetchCategories();
//   };

//   const handleUpdateCategory = async (e) => {
//     e.preventDefault();
//     await axios.put(`${API}/categories/${editCategoryId}`, {
//       name: categoryName,
//       currentUserId,
//     });
//     setEditCategoryId(null);
//     setCategoryName("");
//     fetchCategories();
//   };

//   const deleteCategory = async (id) => {
//     if (window.confirm("Delete Category?")) {
//       await axios.delete(`${API}/categories/${id}`);
//       fetchCategories();
//     }
//   };

//   // ================= SUBCATEGORY =================
//   const handleAddSubcategory = async (e) => {
//     e.preventDefault();
//     await axios.post(`${API}/subcategories`, {
//       categoryId: selectedCategory,
//       name: subcategoryName,
//       userId,
//       currentUserId,
//     });
//     setSubcategoryName("");
//     fetchSubcategories(selectedCategory);
//   };

//   const handleUpdateSubcategory = async (e) => {
//     e.preventDefault();
//     await axios.put(`${API}/subcategories/${editSubcategoryId}`, {
//       name: subcategoryName,
//       categoryId: selectedCategory,
//       currentUserId,
//     });
//     setEditSubcategoryId(null);
//     setSubcategoryName("");
//     fetchSubcategories(selectedCategory);
//   };

//   const deleteSubcategory = async (id) => {
//     if (window.confirm("Delete Subcategory?")) {
//       await axios.delete(`${API}/subcategories/${id}`);
//       fetchSubcategories(selectedCategory);
//     }
//   };

//   // ================= PAGINATION =================
//   const categoryStart = (categoryPage - 1) * ITEMS_PER_PAGE;
//   const categoryEnd = categoryStart + ITEMS_PER_PAGE;
//   const paginatedCategories = categories.slice(categoryStart, categoryEnd);

//   const subStart = (subPage - 1) * ITEMS_PER_PAGE;
//   const subEnd = subStart + ITEMS_PER_PAGE;
//   const paginatedSubcategories = subcategories.slice(subStart, subEnd);

//   /* ===================== STYLES ===================== */

//   const pageBtn = (active) => ({
//     width: "30px",
//     height: "30px",
//     fontSize: "12px",
//     borderRadius: "8px",
//     border: "1px solid #e5e7eb",
//     cursor: "pointer",
//     background: active
//       ? "linear-gradient(135deg,#6366f1,#4f46e5)"
//       : "#fff",
//     color: active ? "#fff" : "#111",
//     boxShadow: active ? "0 4px 10px rgba(79,70,229,0.25)" : "none",
//     transition: "0.25s",
//   });

//   const cardStyle = {
//     flex: "1 1 420px",
//     background: "#ffffff",
//     padding: "18px",
//     borderRadius: "16px",
//     boxShadow: "0 8px 20px rgba(0,0,0,0.06)",
//     border: "1px solid #eef2f7",
//     transition: "0.3s",
//   };

//   const titleStyle = {
//     display: "flex",
//     alignItems: "center",
//     gap: "8px",
//     fontSize: "16px",
//     fontWeight: "700",
//     color: "#1f2a44",
//     marginBottom: "12px",
//   };

//   const inputStyle = {
//     flex: 1,
//     padding: "10px",
//     borderRadius: "10px",
//     border: "1px solid #dbe3ea",
//     outline: "none",
//     fontSize: "13px",
//     transition: "0.2s",
//   };

//   const btnPrimary = {
//     padding: "10px 12px",
//     borderRadius: "10px",
//     border: "none",
//     cursor: "pointer",
//     color: "#fff",
//     background: "linear-gradient(135deg,#4f46e5,#6366f1)",
//     boxShadow: "0 4px 10px rgba(79,70,229,0.25)",
//     transition: "0.25s",
//   };

//   const btnEdit = {
//     padding: "6px 8px",
//     borderRadius: "8px",
//     border: "none",
//     background: "#3b82f6",
//     color: "#fff",
//     cursor: "pointer",
//     transition: "0.2s",
//   };

//   const btnDelete = {
//     padding: "6px 8px",
//     borderRadius: "8px",
//     border: "none",
//     background: "#ef4444",
//     color: "#fff",
//     cursor: "pointer",
//     transition: "0.2s",
//   };

//   const itemCard = {
//     display: "flex",
//     justifyContent: "space-between",
//     padding: "10px",
//     borderRadius: "10px",
//     border: "1px solid #eef2f7",
//     marginBottom: "8px",
//     background: "#fff",
//     transition: "0.25s",
//     cursor: "pointer",
//   };

//   return (
//     <div style={{ minHeight: "100vh", background: "#f1f5f9", padding: "15px" }}>

//       <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>

//         {/* ================= CATEGORY ================= */}
//         <div style={cardStyle}>
//           <h3 style={titleStyle}>
//             <FaTags /> Categories
//           </h3>

//           <form
//             onSubmit={editCategoryId ? handleUpdateCategory : handleAddCategory}
//             style={{ display: "flex", gap: "8px", marginBottom: "12px" }}
//           >
//             <input
//               value={categoryName}
//               onChange={(e) => setCategoryName(e.target.value)}
//               placeholder="Category"
//               style={inputStyle}
//             />

//             <button style={btnPrimary}>
//               <FaPlus /> ADD
//             </button>
//           </form>

//           {paginatedCategories.map((cat, i) => (
//             <div
//               key={cat.id}
//               style={itemCard}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.boxShadow =
//                   "0 6px 14px rgba(0,0,0,0.08)")
//               }
//               onMouseOut={(e) =>
//                 (e.currentTarget.style.boxShadow = "none")
//               }
//             >
//               <span style={{ fontSize: "13px", fontWeight: "600" }}>
//                 {categoryStart + i + 1}. {cat.name}
//               </span>

//               <div style={{ display: "flex", gap: "6px" }}>
//                 <button
//                   style={btnEdit}
//                   onClick={() => {
//                     setEditCategoryId(cat.id);
//                     setCategoryName(cat.name);
//                   }}
//                 >
//                   <FaPencilAlt />
//                 </button>

//                 <button
//                   style={btnDelete}
//                   onClick={() => deleteCategory(cat.id)}
//                 >
//                   <FaTrash />
//                 </button>
//               </div>
//             </div>
//           ))}

//           <div style={{ display: "flex", justifyContent: "flex-end", gap: "5px" }}>
//             {Array.from({ length: Math.ceil(categories.length / ITEMS_PER_PAGE) }).map((_, i) => (
//               <button
//                 key={i}
//                 onClick={() => setCategoryPage(i + 1)}
//                 style={pageBtn(categoryPage === i + 1)}
//               >
//                 {i + 1}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* ================= SUBCATEGORY ================= */}
//         <div style={cardStyle}>
//           <h3 style={titleStyle}>
//             <FaListUl /> Subcategories
//           </h3>

//           <form
//             onSubmit={editSubcategoryId ? handleUpdateSubcategory : handleAddSubcategory}
//             style={{ display: "flex", gap: "8px", marginBottom: "12px" }}
//           >
//             <select
//               value={selectedCategory}
//               onChange={(e) => {
//                 setSelectedCategory(e.target.value);
//                 fetchSubcategories(e.target.value);
//                 setSubPage(1);
//               }}
//               style={inputStyle}
//             >
//               <option>Select</option>
//               {categories.map((c) => (
//                 <option key={c.id} value={c.id}>
//                   {c.name}
//                 </option>
//               ))}
//             </select>

//             <input
//               value={subcategoryName}
//               onChange={(e) => setSubcategoryName(e.target.value)}
//               placeholder="Subcategory"
//               style={inputStyle}
//             />

//             <button style={btnPrimary}>
//               <FaPlus /> SUB
//             </button>
//           </form>

//           {paginatedSubcategories.map((sub, i) => (
//             <div key={sub.id} style={itemCard}>
//               <span style={{ fontSize: "13px", fontWeight: "600" }}>
//                 {subStart + i + 1}. {sub.name}
//               </span>

//               <div style={{ display: "flex", gap: "6px" }}>
//                 <button
//                   style={btnEdit}
//                   onClick={() => {
//                     setEditSubcategoryId(sub.id);
//                     setSubcategoryName(sub.name);
//                     setSelectedCategory(sub.category_id);
//                   }}
//                 >
//                   <FaPencilAlt />
//                 </button>

//                 <button
//                   style={btnDelete}
//                   onClick={() => deleteSubcategory(sub.id)}
//                 >
//                   <FaTrash />
//                 </button>
//               </div>
//             </div>
//           ))}

//           <div style={{ display: "flex", justifyContent: "flex-end", gap: "5px" }}>
//             {Array.from({ length: Math.ceil(subcategories.length / ITEMS_PER_PAGE) }).map((_, i) => (
//               <button
//                 key={i}
//                 onClick={() => setSubPage(i + 1)}
//                 style={pageBtn(subPage === i + 1)}
//               >
//                 {i + 1}
//               </button>
//             ))}
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default CategoryPage;


import React, { useEffect, useState } from "react";
import axios from "axios";
import { 
  Plus, 
  Edit, 
  Trash2, 
  Tag, 
  Layers, 
  Check, 
  X, 
  FolderPlus, 
  ChevronLeft, 
  ChevronRight 
} from "lucide-react";

const API = "https://cloudapi.emedhatechnologies.com/pages/api/api";
const ITEMS_PER_PAGE = 3; // Swapped to match the design code layout index threshold

const CategoryPage = () => {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  // Controlled form input management pairs
  const [categoryName, setCategoryName] = useState("");
  const [subcategoryName, setSubcategoryName] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  // Edit trackers
  const [editCategoryId, setEditCategoryId] = useState(null);
  const [editSubcategoryId, setEditSubcategoryId] = useState(null);
  const [editValue, setEditValue] = useState("");

  // Session User context variables
  const user = JSON.parse(sessionStorage.getItem("userData")) || {};
  const userId = user.type === "employee" ? user.parent_company_id : user.id;
  const currentUserId = user.id;

  // Pagination states matching design panel code specs
  const [catCurrentPage, setCatCurrentPage] = useState(1);
  const [subCurrentPage, setSubCurrentPage] = useState(1);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${API}/categories?userId=${userId}`);
      setCategories(res.data || []);
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  const fetchSubcategories = async (categoryId) => {
    if (!categoryId) {
      setSubcategories([]);
      return;
    }
    try {
      const res = await axios.get(
        `${API}/subcategories?categoryId=${categoryId}&userId=${userId}`
      );
      setSubcategories(res.data || []);
    } catch (err) {
      console.error("Error fetching subcategories:", err);
    }
  };

  // Helper adjustment logic matching the design source blueprint
  const adjustPageAfterDeletion = (totalItemsBefore, currentPage, setPage) => {
    const totalPagesAfter = Math.ceil((totalItemsBefore - 1) / ITEMS_PER_PAGE) || 1;
    if (currentPage > totalPagesAfter) {
      setPage(totalPagesAfter);
    }
  };

  // ================= CATEGORY OPERATIONS =================
  const handleAddCategory = async (e) => {
    e.preventDefault();
    if (!categoryName.trim()) return;

    await axios.post(`${API}/categories`, {
      name: categoryName.trim(),
      userId,
      currentUserId,
    });
    setCategoryName("");
    
    // Refresh & jump index to newly added category page calculation thresholds
    const nextTotalPages = Math.ceil((categories.length + 1) / ITEMS_PER_PAGE);
    setCatCurrentPage(nextTotalPages);
    fetchCategories();
  };

  const handleStartEditCategory = (id, name) => {
    setEditCategoryId(id);
    setEditValue(name);
  };

  const handleSaveCategoryEdit = async (id) => {
    if (!editValue.trim()) return;
    await axios.put(`${API}/categories/${id}`, {
      name: editValue.trim(),
      currentUserId,
    });
    setEditCategoryId(null);
    setEditValue("");
    fetchCategories();
  };

  const deleteCategory = async (id) => {
    if (window.confirm("Delete Category?")) {
      adjustPageAfterDeletion(categories.length, catCurrentPage, setCatCurrentPage);
      await axios.delete(`${API}/categories/${id}`);
      if (selectedCategory === id.toString() || selectedCategory === id) {
        setSelectedCategory("");
        setSubcategories([]);
        setSubCurrentPage(1);
      }
      fetchCategories();
    }
  };

  // ================= SUBCATEGORY OPERATIONS =================
  const handleAddSubcategory = async (e) => {
    e.preventDefault();
    if (!selectedCategory || !subcategoryName.trim()) return;

    await axios.post(`${API}/subcategories`, {
      categoryId: selectedCategory,
      name: subcategoryName.trim(),
      userId,
      currentUserId,
    });
    setSubcategoryName("");
    
    // Auto shift view indexes on addition update
    const nextSubPages = Math.ceil((subcategories.length + 1) / ITEMS_PER_PAGE);
    setSubCurrentPage(nextSubPages);
    fetchSubcategories(selectedCategory);
  };

  const handleStartEditSub = (id, name) => {
    setEditSubcategoryId(id);
    setEditValue(name);
  };

  const handleSaveSubEdit = async (subId) => {
    if (!editValue.trim()) return;
    await axios.put(`${API}/subcategories/${subId}`, {
      name: editValue.trim(),
      categoryId: selectedCategory,
      currentUserId,
    });
    setEditSubcategoryId(null);
    setEditValue("");
    fetchSubcategories(selectedCategory);
  };

  const deleteSubcategory = async (id) => {
    if (window.confirm("Delete Subcategory?")) {
      adjustPageAfterDeletion(subcategories.length, subCurrentPage, setSubCurrentPage);
      await axios.delete(`${API}/subcategories/${id}`);
      fetchSubcategories(selectedCategory);
    }
  };

  // ================= PAGINATION CALCULATIONS =================
  const totalCatPages = Math.ceil(categories.length / ITEMS_PER_PAGE) || 1;
  const totalSubPages = Math.ceil(subcategories.length / ITEMS_PER_PAGE) || 1;

  const displayedCategories = categories.slice(
    (catCurrentPage - 1) * ITEMS_PER_PAGE,
    catCurrentPage * ITEMS_PER_PAGE
  );

  const displayedSubcategories = subcategories.slice(
    (subCurrentPage - 1) * ITEMS_PER_PAGE,
    subCurrentPage * ITEMS_PER_PAGE
  );

  return (
    <div style={{
    //   padding: '24px',
      maxWidth: '1280px',
      marginLeft: 'auto',
      marginRight: 'auto',
      minHeight: '100vh',
      backgroundColor: 'rgba(250, 250, 250, 0.5)',
      color: '#262626',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      
      {/* HEADER BAR */}
      <div style={{
        marginBottom: '32px',
        borderBottom: '1px solid rgba(229, 229, 229, 0.6)',
        paddingBottom: '20px'
      }}>
        <h1 style={{
          fontSize: '24px',
          fontWeight: '700',
          letterSpacing: '-0.025em',
          color: '#171717',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          margin: 0
        }}>
          <div style={{
            padding: '8px',
            backgroundColor: '#e0e7ff',
            borderRadius: '12px',
            border: '1px solid #c7d2fe',
            display: 'flex'
          }}>
            <FolderPlus style={{ width: '24px', height: '24px', color: '#4f46e5' }} />
          </div>
          Classification Master
        </h1>
        <p style={{ fontSize: '14px', color: '#737373', marginTop: '4px', paddingLeft: '4px', marginBottom: 0 }}>
          Configure hierarchical relationship levels quickly and seamlessly.
        </p>
      </div>

      {/* RESPONSIVE LAYOUT GRID */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
        gap: '32px',
        alignItems: 'start'
      }}>
        
        {/* PANEL 1: MAIN CATEGORIES */}
        <div style={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(229, 229, 229, 0.7)',
          borderRadius: '16px',
          padding: '24px',
          boxShadow: '0 2px 8px -3px rgba(0,0,0,0.05)',
          transition: 'all 0.3s'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifycontent: 'space-between', justifyContent: 'space-between', marginBottom: '16px' }}>
            <h2 style={{ fontSize: '18px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px', color: '#171717', margin: 0 }}>
              <Tag style={{ width: '18px', height: '18px', color: '#4f46e5' }} /> Main Categories
            </h2>
            <span style={{
              fontSize: '11px',
              fontWeight: '500',
              backgroundColor: '#e0e7ff',
              border: '1px solid #c7d2fe',
              padding: '2px 8px',
              borderRadius: '9999px',
              color: '#4f46e5'
            }}>
              {categories.length} Total
            </span>
          </div>
          
          {/* Form Input Container */}
          <form onSubmit={handleAddCategory} style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
            <input 
              type="text"
              placeholder="Create main category name..."
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              style={{
                flex: 1,
                padding: '8px 12px',
                backgroundColor: '#fafafa',
                border: '1px solid #e5e7eb',
                borderRadius: '12px',
                outline: 'none',
                fontSize: '14px',
                color: '#171717',
                boxSizing: 'border-box'
              }}
            />
            <button type="submit" style={{
              backgroundColor: '#4f46e5',
              color: '#ffffff',
              padding: '8px 16px',
              borderRadius: '12px',
              fontSize: '14px',
              fontWeight: '500',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              flexShrink: 0
            }}>
              <Plus style={{ width: '16px', height: '16px' }} /> Add
            </button>
          </form>

          {/* Items List Wrapper */}
          <div style={{
            border: '1px solid rgba(229, 229, 229, 0.6)',
            borderRadius: '12px',
            overflow: 'hidden',
            backgroundColor: 'rgba(250, 250, 250, 0.2)'
          }}>
            <div style={{ minHeight: '180px', display: 'flex', flexDirection: 'column' }}>
              {displayedCategories.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '64px 0', color: '#a3a3a3', fontSize: '14px', fontStyle: 'italic', flex: 1 }}>
                  No entries configured yet.
                </div>
              ) : (
                displayedCategories.map((category) => (
                  <div key={category.id} style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '12px',
                    fontSize: '14px',
                    borderBottom: '1px solid #f5f5f5',
                    backgroundColor: selectedCategory === category.id.toString() || selectedCategory === category.id ? 'rgba(224, 231, 255, 0.4)' : 'transparent'
                  }}>
                    {editCategoryId === category.id ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1, marginRight: '8px' }}>
                        <input 
                          type="text"
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                          style={{
                            flex: 1,
                            padding: '6px 10px',
                            border: '1px solid #4f46e5',
                            backgroundColor: '#ffffff',
                            borderRadius: '8px',
                            outline: 'none',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: '#171717'
                          }}
                          autoFocus
                        />
                        <button onClick={() => handleSaveCategoryEdit(category.id)} style={{ padding: '6px', backgroundColor: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0', borderRadius: '8px', cursor: 'pointer', display: 'flex' }}>
                          <Check style={{ width: '16px', height: '16px' }} />
                        </button>
                        <button onClick={() => setEditCategoryId(null)} style={{ padding: '6px', backgroundColor: '#f5f5f5', color: '#737373', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', display: 'flex' }}>
                          <X style={{ width: '16px', height: '16px' }} />
                        </button>
                      </div>
                    ) : (
                      <>
                        <div 
                          onClick={() => { 
                            setSelectedCategory(category.id.toString()); 
                            fetchSubcategories(category.id);
                            setSubCurrentPage(1); 
                          }}
                          style={{ display: 'flex', flexDirection: 'column', gap: '2px', cursor: 'pointer', flex: 1 }}
                        >
                          <span style={{ fontWeight: '600', color: (selectedCategory === category.id.toString() || selectedCategory === category.id) ? '#4338ca' : '#262626' }}>{category.name}</span>
                          <span style={{ fontSize: '10px', letterSpacing: '0.05em', color: '#a3a3a3', fontFamily: 'monospace', textTransform: 'uppercase' }}>ID: {category.id}</span>
                        </div>
                        <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
                          <button onClick={() => handleStartEditCategory(category.id, category.name)} style={{ padding: '6px', color: '#a3a3a3', backgroundColor: 'transparent', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
                            <Edit style={{ width: '16px', height: '16px' }} />
                          </button>
                          <button onClick={() => deleteCategory(category.id)} style={{ padding: '6px', color: '#a3a3a3', backgroundColor: 'transparent', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
                            <Trash2 style={{ width: '16px', height: '16px' }} />
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                ))
              )}
            </div>

            {/* Pagination Controls Footer */}
            {categories.length > 0 && (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 16px',
                backgroundColor: 'rgba(250, 250, 250, 0.8)',
                borderTop: '1px solid rgba(229, 229, 229, 0.6)',
                fontSize: '12px',
                color: '#737373',
                userSelect: 'none'
              }}>
                <span>Page <b style={{ color: '#171717' }}>{catCurrentPage}</b> of {totalCatPages}</span>
                <div style={{ display: 'flex', gap: '4px' }}>
                  <button 
                    type="button"
                    disabled={catCurrentPage === 1}
                    onClick={() => setCatCurrentPage(p => Math.max(p - 1, 1))}
                    style={{
                      padding: '4px',
                      backgroundColor: '#ffffff',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      color: '#404040',
                      cursor: catCurrentPage === 1 ? 'not-allowed' : 'pointer',
                      opacity: catCurrentPage === 1 ? 0.4 : 1,
                      display: 'flex'
                    }}
                  >
                    <ChevronLeft style={{ width: '16px', height: '16px' }} />
                  </button>
                  <button 
                    type="button"
                    disabled={catCurrentPage === totalCatPages}
                    onClick={() => setCatCurrentPage(p => Math.min(p + 1, totalCatPages))}
                    style={{
                      padding: '4px',
                      backgroundColor: '#ffffff',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      color: '#404040',
                      cursor: catCurrentPage === totalCatPages ? 'not-allowed' : 'pointer',
                      opacity: catCurrentPage === totalCatPages ? 0.4 : 1,
                      display: 'flex'
                    }}
                  >
                    <ChevronRight style={{ width: '16px', height: '16px' }} />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* PANEL 2: SUBCATEGORY MAPPING */}
        <div style={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(229, 229, 229, 0.7)',
          borderRadius: '16px',
          padding: '24px',
          boxShadow: '0 2px 8px -3px rgba(0,0,0,0.05)',
          transition: 'all 0.3s'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
            <h2 style={{ fontSize: '18px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px', color: '#171717', margin: 0 }}>
              <Layers style={{ width: '18px', height: '18px', color: '#7c3aed' }} /> Subcategory Mapping
            </h2>
            {selectedCategory && (
              <span style={{
                fontSize: '11px',
                fontWeight: '500',
                backgroundColor: '#f5f3ff',
                border: '1px solid #ddd6fe',
                padding: '2px 8px',
                borderRadius: '9999px',
                color: '#7c3aed'
              }}>
                {subcategories.length} Children
              </span>
            )}
          </div>

          {/* Dropdown Selection */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '16px' }}>
            <label style={{ fontSize: '11px', fontWeight: '700', color: '#a3a3a3', textTransform: 'uppercase', letterSpacing: '0.05em', paddingLeft: '2px' }}>
              Bind to Parent Category
            </label>
            <select 
              value={selectedCategory}
              onChange={(e) => { 
                setSelectedCategory(e.target.value); 
                setEditSubcategoryId(null); 
                fetchSubcategories(e.target.value);
                setSubCurrentPage(1); 
              }}
              style={{
                width: '100%',
                padding: '8px 12px',
                backgroundColor: '#fafafa',
                border: '1px solid #e5e7eb',
                borderRadius: '12px',
                textTransform: 'none',
                fontSize: '14px',
                fontWeight: '500',
                color: '#404040',
                outline: 'none',
                cursor: 'pointer'
              }}
            >
              <option value="">Select Category Parent...</option>
              {categories.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>

          {/* Subcategory Action Entry Form */}
          <form onSubmit={handleAddSubcategory} style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
            <input 
              type="text"
              placeholder={selectedCategory ? "Create subcategory name..." : "Select parent first..."}
              disabled={!selectedCategory}
              value={subcategoryName}
              onChange={(e) => setSubcategoryName(e.target.value)}
              style={{
                flex: 1,
                padding: '8px 12px',
                backgroundColor: selectedCategory ? '#fafafa' : '#f5f5f5',
                border: '1px solid #e5e7eb',
                borderRadius: '12px',
                outline: 'none',
                fontSize: '14px',
                color: '#171717',
                boxSizing: 'border-box',
                cursor: selectedCategory ? 'text' : 'not-allowed'
              }}
            />
            <button 
              type="submit" 
              disabled={!selectedCategory}
              style={{
                backgroundColor: selectedCategory ? '#7c3aed' : '#a78bfa',
                color: '#ffffff',
                padding: '8px 16px',
                borderRadius: '12px',
                fontSize: '14px',
                fontWeight: '500',
                border: 'none',
                cursor: selectedCategory ? 'pointer' : 'not-allowed',
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                flexShrink: 0
              }}
            >
              <Plus style={{ width: '16px', height: '16px' }} /> Add
            </button>
          </form>

          {/* Subcategories Items Wrapper */}
          <div style={{
            border: '1px solid rgba(229, 229, 229, 0.6)',
            borderRadius: '12px',
            overflow: 'hidden',
            backgroundColor: 'rgba(250, 250, 250, 0.2)'
          }}>
            <div style={{ minHeight: '180px', display: 'flex', flexDirection: 'column' }}>
              {!selectedCategory ? (
                <div style={{ textAlign: 'center', padding: '64px 24px', color: '#a3a3a3', fontSize: '14px', fontStyle: 'italic', flex: 1 }}>
                  Choose a main parent configuration layer to view children.
                </div>
              ) : displayedSubcategories.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '64px 0', color: '#a3a3a3', fontSize: '14px', fontStyle: 'italic', flex: 1 }}>
                  No subcategory entry children verified.
                </div>
              ) : (
                displayedSubcategories.map((sub) => (
                  <div key={sub.id} style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '12px',
                    fontSize: '14px',
                    borderBottom: '1px solid #f5f5f5'
                  }}>
                    {editSubcategoryId === sub.id ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1, marginRight: '8px' }}>
                        <input 
                          type="text"
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                          style={{
                            flex: 1,
                            padding: '6px 10px',
                            border: '1px solid #7c3aed',
                            backgroundColor: '#ffffff',
                            borderRadius: '8px',
                            outline: 'none',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: '#171717'
                          }}
                          autoFocus
                        />
                        <button onClick={() => handleSaveSubEdit(sub.id)} style={{ padding: '6px', backgroundColor: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0', borderRadius: '8px', cursor: 'pointer', display: 'flex' }}>
                          <Check style={{ width: '16px', height: '16px' }} />
                        </button>
                        <button onClick={() => setEditSubcategoryId(null)} style={{ padding: '6px', backgroundColor: '#f5f5f5', color: '#737373', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', display: 'flex' }}>
                          <X style={{ width: '16px', height: '16px' }} />
                        </button>
                      </div>
                    ) : (
                      <>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', flex: 1 }}>
                          <span style={{ fontWeight: '600', color: '#262626' }}>{sub.name}</span>
                          <span style={{ fontSize: '10px', letterSpacing: '0.05em', color: '#a3a3a3', fontFamily: 'monospace', textTransform: 'uppercase' }}>ID: {sub.id}</span>
                        </div>
                        <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
                          <button onClick={() => handleStartEditSub(sub.id, sub.name)} style={{ padding: '6px', color: '#a3a3a3', backgroundColor: 'transparent', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
                            <Edit style={{ width: '16px', height: '16px' }} />
                          </button>
                          <button onClick={() => deleteSubcategory(sub.id)} style={{ padding: '6px', color: '#a3a3a3', backgroundColor: 'transparent', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
                            <Trash2 style={{ width: '16px', height: '16px' }} />
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                ))
              )}
            </div>

            {/* Pagination Controls Sub-Panel Footer */}
            {selectedCategory && subcategories.length > 0 && (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 16px',
                backgroundColor: 'rgba(250, 250, 250, 0.8)',
                borderTop: '1px solid rgba(229, 229, 229, 0.6)',
                fontSize: '12px',
                color: '#737373',
                userSelect: 'none'
              }}>
                <span>Page <b style={{ color: '#171717' }}>{subCurrentPage}</b> of {totalSubPages}</span>
                <div style={{ display: 'flex', gap: '4px' }}>
                  <button 
                    type="button"
                    disabled={subCurrentPage === 1}
                    onClick={() => setSubCurrentPage(p => Math.max(p - 1, 1))}
                    style={{
                      padding: '4px',
                      backgroundColor: '#ffffff',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      color: '#404040',
                      cursor: subCurrentPage === 1 ? 'not-allowed' : 'pointer',
                      opacity: subCurrentPage === 1 ? 0.4 : 1,
                      display: 'flex'
                    }}
                  >
                    <ChevronLeft style={{ width: '16px', height: '16px' }} />
                  </button>
                  <button 
                    type="button"
                    disabled={subCurrentPage === totalSubPages}
                    onClick={() => setSubCurrentPage(p => Math.min(p + 1, totalSubPages))}
                    style={{
                      padding: '4px',
                      backgroundColor: '#ffffff',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      color: '#404040',
                      cursor: subCurrentPage === totalSubPages ? 'not-allowed' : 'pointer',
                      opacity: subCurrentPage === totalSubPages ? 0.4 : 1,
                      display: 'flex'
                    }}
                  >
                    <ChevronRight style={{ width: '16px', height: '16px' }} />
                  </button>
                </div>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default CategoryPage;






// import React, { useState } from 'react';
// import { 
//   Plus, 
//   Edit, 
//   Trash2, 
//   Tag, 
//   Layers, 
//   Check, 
//   X, 
//   FolderPlus, 
//   ChevronLeft, 
//   ChevronRight 
// } from 'lucide-react';

// const initialData = [
//   {
//     id: 'CAT-1',
//     name: 'Electronics',
//     subcategories: [
//       { id: 'SUB-1', name: 'Mobiles' },
//       { id: 'SUB-2', name: 'Laptops' },
//       { id: 'SUB-3', name: 'Tablets' },
//       { id: 'SUB-4', name: 'Smartwatches' }
//     ]
//   },
//   {
//     id: 'CAT-2',
//     name: 'Furniture',
//     subcategories: [
//       { id: 'SUB-5', name: 'Chairs' },
//       { id: 'SUB-6', name: 'Tables' }
//     ]
//   },
//   { id: 'CAT-3', name: 'Apparel', subcategories: [] },
//   { id: 'CAT-4', name: 'Books', subcategories: [] },
//   { id: 'CAT-5', name: 'Fitness', subcategories: [] }
// ];

// const ITEMS_PER_PAGE = 3;

// const CategoryPage = () => {
//   const [categories, setCategories] = useState(initialData);
//   const [selectedCatId, setSelectedCatId] = useState('');

//   // Input states for Add/Edit
//   const [categoryInput, setCategoryInput] = useState('');
//   const [subcategoryInput, setSubcategoryInput] = useState('');
  
//   const [editingCatId, setEditingCatId] = useState(null);
//   const [editingSubId, setEditingSubId] = useState(null);
//   const [editValue, setEditValue] = useState('');

//   // Pagination States
//   const [catCurrentPage, setCatCurrentPage] = useState(1);
//   const [subCurrentPage, setSubCurrentPage] = useState(1);

//   // Get active subcategories based on dropdown selection
//   const activeCategory = categories.find(cat => cat.id === selectedCatId);

//   // --- Pagination Calculators ---
//   const totalCatPages = Math.ceil(categories.length / ITEMS_PER_PAGE) || 1;
//   const activeSubcategories = activeCategory?.subcategories || [];
//   const totalSubPages = Math.ceil(activeSubcategories.length / ITEMS_PER_PAGE) || 1;

//   // Sliced data lists for presentation
//   const displayedCategories = categories.slice(
//     (catCurrentPage - 1) * ITEMS_PER_PAGE,
//     catCurrentPage * ITEMS_PER_PAGE
//   );

//   const displayedSubcategories = activeSubcategories.slice(
//     (subCurrentPage - 1) * ITEMS_PER_PAGE,
//     subCurrentPage * ITEMS_PER_PAGE
//   );

//   // Helper to ensure current page index is safe post-deletion
//   const adjustPageAfterDeletion = (totalItemsBefore, currentPage, setPage) => {
//     const totalPagesAfter = Math.ceil((totalItemsBefore - 1) / ITEMS_PER_PAGE) || 1;
//     if (currentPage > totalPagesAfter) {
//       setPage(totalPagesAfter);
//     }
//   };

//   // --- Main Category Handlers ---
//   const handleAddCategory = (e) => {
//     e.preventDefault();
//     if (!categoryInput.trim()) return;

//     const newCategory = {
//       id: `CAT-${Date.now()}`,
//       name: categoryInput.trim(),
//       subcategories: []
//     };

//     const updatedCategories = [...categories, newCategory];
//     setCategories(updatedCategories);
//     setCategoryInput('');
    
//     // Jump to the newly added item page
//     const nextTotalPages = Math.ceil(updatedCategories.length / ITEMS_PER_PAGE);
//     setCatCurrentPage(nextTotalPages);
//   };

//   const handleStartEditCategory = (id, name) => {
//     setEditingCatId(id);
//     setEditValue(name);
//   };

//   const handleSaveCategoryEdit = (id) => {
//     if (!editValue.trim()) return;
//     setCategories(categories.map(cat => 
//       cat.id === id ? { ...cat, name: editValue.trim() } : cat
//     ));
//     setEditingCatId(null);
//     setEditValue('');
//   };

//   const handleDeleteCategory = (id) => {
//     adjustPageAfterDeletion(categories.length, catCurrentPage, setCatCurrentPage);
//     setCategories(categories.filter(cat => cat.id !== id));
//     if (selectedCatId === id) {
//       setSelectedCatId('');
//       setSubCurrentPage(1);
//     }
//   };

//   // --- Subcategory Handlers ---
//   const handleAddSubcategory = (e) => {
//     e.preventDefault();
//     if (!selectedCatId || !subcategoryInput.trim()) return;

//     let targetNewLength = 0;

//     setCategories(categories.map(cat => {
//       if (cat.id === selectedCatId) {
//         const nextSubs = [
//           ...cat.subcategories,
//           { id: `SUB-${Date.now()}`, name: subcategoryInput.trim() }
//         ];
//         targetNewLength = nextSubs.length;
//         return { ...cat, subcategories: nextSubs };
//       }
//       return cat;
//     }));
    
//     setSubcategoryInput('');
//     if (targetNewLength > 0) {
//       setSubCurrentPage(Math.ceil(targetNewLength / ITEMS_PER_PAGE));
//     }
//   };

//   const handleStartEditSub = (id, name) => {
//     setEditingSubId(id);
//     setEditValue(name);
//   };

//   const handleSaveSubEdit = (subId) => {
//     if (!editValue.trim()) return;
//     setCategories(categories.map(cat => {
//       if (cat.id === selectedCatId) {
//         return {
//           ...cat,
//           subcategories: cat.subcategories.map(sub => 
//             sub.id === subId ? { ...sub, name: editValue.trim() } : sub
//           )
//         };
//       }
//       return cat;
//     }));
//     setEditingSubId(null);
//     setEditValue('');
//   };

//   const handleDeleteSubcategory = (subId) => {
//     adjustPageAfterDeletion(activeSubcategories.length, subCurrentPage, setSubCurrentPage);
//     setCategories(categories.map(cat => {
//       if (cat.id === selectedCatId) {
//         return {
//           ...cat,
//           subcategories: cat.subcategories.filter(sub => sub.id !== subId)
//         };
//       }
//       return cat;
//     }));
//   };

//   return (
//     /* className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto min-h-screen bg-neutral-50/50 text-neutral-800 antialiased selection:bg-indigo-500/10" */
//     <div style={{
//       padding: '24px',
//       maxWidth: '1280px',
//       marginLeft: 'auto',
//       marginRight: 'auto',
//       minHeight: '100vh',
//       backgroundColor: 'rgba(250, 250, 250, 0.5)',
//       color: '#262626',
//       fontFamily: 'system-ui, -apple-system, sans-serif'
//     }}>
      
//       {/* HEADER BAR */}
//       {/* className="mb-6 sm:mb-8 border-b border-neutral-200/60 pb-5" */}
//       <div style={{
//         marginBottom: '32px',
//         borderBottom: '1px solid rgba(229, 229, 229, 0.6)',
//         paddingBottom: '20px'
//       }}>
//         {/* className="text-xl sm:text-2xl font-bold tracking-tight text-neutral-900 flex items-center gap-2.5" */}
//         <h1 style={{
//           fontSize: '24px',
//           fontWeight: '700',
//           letterSpacing: '-0.025em',
//           color: '#171717',
//           display: 'flex',
//           alignItems: 'center',
//           gap: '10px',
//           margin: 0
//         }}>
//           {/* className="p-2 bg-indigo-50 rounded-xl border border-indigo-100" */}
//           <div style={{
//             padding: '8px',
//             backgroundColor: '#e0e7ff',
//             borderRadius: '12px',
//             border: '1px solid #c7d2fe',
//             display: 'flex'
//           }}>
//             {/* className="w-5 h-5 sm:w-6 sm:h-6 text-indigo-600" */}
//             <FolderPlus style={{ width: '24px', height: '24px', color: '#4f46e5' }} />
//           </div>
//           Classification Master
//         </h1>
//         {/* className="text-xs sm:text-sm text-neutral-500 mt-1 pl-1" */}
//         <p style={{ fontSize: '14px', color: '#737373', marginTop: '4px', paddingLeft: '4px', marginBottom: 0 }}>
//           Configure hierarchical relationship levels quickly and seamlessly.
//         </p>
//       </div>

//       {/* RESPONSIVE LAYOUT GRID */}
//       {/* className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 items-start" */}
//       <div style={{
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
//         gap: '32px',
//         alignItems: 'start'
//       }}>
        
//         {/* PANEL 1: MAIN CATEGORIES */}
//         {/* className="bg-white border border-neutral-200/70 rounded-2xl p-4 sm:p-5 lg:p-6 shadow-[0_2px_8px_-3px_rgba(0,0,0,0.05)] hover:shadow-[0_4px_16px_-4px_rgba(0,0,0,0.08)] transition-all duration-300" */}
//         <div style={{
//           backgroundColor: '#ffffff',
//           border: '1px solid rgba(229, 229, 229, 0.7)',
//           borderRadius: '16px',
//           padding: '24px',
//           boxShadow: '0 2px 8px -3px rgba(0,0,0,0.05)',
//           transition: 'all 0.3s'
//         }}>
//           {/* className="flex items-center justify-between mb-4" */}
//           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
//             {/* className="text-base sm:text-lg font-bold flex items-center gap-2 text-neutral-900" */}
//             <h2 style={{ fontSize: '18px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px', color: '#171717', margin: 0 }}>
//               <Tag style={{ width: '18px', height: '18px', color: '#4f46e5' }} /> Main Categories
//             </h2>
//             {/* className="text-[11px] font-medium bg-indigo-50 border border-indigo-100 px-2 py-0.5 rounded-full text-indigo-600" */}
//             <span style={{
//               fontSize: '11px',
//               fontWeight: '500',
//               backgroundColor: '#e0e7ff',
//               border: '1px solid #c7d2fe',
//               padding: '2px 8px',
//               borderRadius: '9999px',
//               color: '#4f46e5'
//             }}>
//               {categories.length} Total
//             </span>
//           </div>
          
//           {/* Form Input Container */}
//           {/* className="flex gap-2 mb-4" */}
//           <form onSubmit={handleAddCategory} style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
//             {/* className="flex-1 px-3 py-2 bg-neutral-50 border border-neutral-200 rounded-xl outline-none text-sm text-neutral-900 placeholder:text-neutral-400 focus:border-indigo-500 focus:bg-white focus:ring-4 focus:ring-indigo-500/10 transition-all" */}
//             <input 
//               type="text"
//               placeholder="Create main category name..."
//               value={categoryInput}
//               onChange={(e) => setCategoryInput(e.target.value)}
//               style={{
//                 flex: 1,
//                 padding: '8px 12px',
//                 backgroundColor: '#fafafa',
//                 border: '1px solid #e5e7eb',
//                 borderRadius: '12px',
//                 outline: 'none',
//                 fontSize: '14px',
//                 color: '#171717',
//                 boxSizing: 'border-box'
//               }}
//             />
//             {/* className="bg-indigo-600 text-white px-4 py-2 rounded-xl text-sm font-medium hover:bg-indigo-700 shadow-sm shadow-indigo-500/20 active:scale-[0.98] transition-transform flex items-center gap-1 shrink-0" */}
//             <button type="submit" style={{
//               backgroundColor: '#4f46e5',
//               color: '#ffffff',
//               padding: '8px 16px',
//               borderRadius: '12px',
//               fontSize: '14px',
//               fontWeight: '500',
//               border: 'none',
//               cursor: 'pointer',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '4px',
//               flexShrink: 0
//             }}>
//               <Plus style={{ width: '16px', height: '16px' }} /> Add
//             </button>
//           </form>

//           {/* Items List Wrapper */}
//           {/* className="border border-neutral-200/60 rounded-xl overflow-hidden bg-neutral-50/20 shadow-inner" */}
//           <div style={{
//             border: '1px solid rgba(229, 229, 229, 0.6)',
//             borderRadius: '12px',
//             overflow: 'hidden',
//             backgroundColor: 'rgba(250, 250, 250, 0.2)'
//           }}>
//             {/* className="divide-y divide-neutral-100 min-h-[180px]" */}
//             <div style={{ minHeight: '180px', display: 'flex', flexDirection: 'column' }}>
//               {displayedCategories.length === 0 ? (
//                 {/* className="text-center py-16 text-neutral-400 text-sm italic" */},
//                 <div style={{ textAlign: 'center', padding: '64px 0', color: '#a3a3a3', fontSize: '14px', fontStyle: 'italic', flex: 1 }}>
//                   No entries configured yet.
//                 </div>
//               ) : (
//                 displayedCategories.map(category => (
//                   {/* className={`flex items-center justify-between p-3 transition-colors text-sm ${selectedCatId === category.id ? 'bg-indigo-50/40' : 'hover:bg-neutral-50'}`} */},
//                   <div key={category.id} style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'space-between',
//                     padding: '12px',
//                     fontSize: '14px',
//                     borderBottom: '1px solid #f5f5f5',
//                     backgroundColor: selectedCatId === category.id ? 'rgba(224, 231, 255, 0.4)' : 'transparent'
//                   }}>
//                     {editingCatId === category.id ? (
                      
//                       <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1, marginRight: '8px' }}>
//                         {/* className="flex-1 px-2.5 py-1.5 border border-indigo-500 bg-white rounded-lg outline-none text-sm font-medium text-neutral-900" */}
//                         <input 
//                           type="text"
//                           value={editValue}
//                           onChange={(e) => setEditValue(e.target.value)}
//                           style={{
//                             flex: 1,
//                             padding: '6px 10px',
//                             border: '1px solid #4f46e5',
//                             backgroundColor: '#ffffff',
//                             borderRadius: '8px',
//                             outline: 'none',
//                             fontSize: '14px',
//                             fontWeight: '500',
//                             color: '#171717'
//                           }}
//                           autoFocus
//                         />
//                         {/* className="p-1.5 bg-green-50 text-green-600 border border-green-200 rounded-lg hover:bg-green-100 transition-colors" */}
//                         <button onClick={() => handleSaveCategoryEdit(category.id)} style={{ padding: '6px', backgroundColor: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0', borderRadius: '8px', cursor: 'pointer', display: 'flex' }}><Check style={{ width: '16px', height: '16px' }} /></button>
//                         {/* className="p-1.5 bg-neutral-100 text-neutral-500 border border-neutral-200 rounded-lg hover:bg-neutral-200 transition-colors" */}
//                         <button onClick={() => setEditingCatId(null)} style={{ padding: '6px', backgroundColor: '#f5f5f5', color: '#737373', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', display: 'flex' }}><X style={{ width: '16px', height: '16px' }} /></button>
//                       </div>
//                     ) : (
//                       <>
//                         {/* className="flex flex-col gap-0.5 cursor-pointer flex-1" */}
//                         <div 
//                           onClick={() => { setSelectedCatId(category.id); setSubCurrentPage(1); }}
//                           style={{ display: 'flex', flexDirection: 'column', gap: '2px', cursor: 'pointer', flex: 1 }}
//                         >
//                           {/* className={`font-semibold transition-colors ${selectedCatId === category.id ? 'text-indigo-700' : 'text-neutral-800'}`} */}
//                           <span style={{ fontWeight: '600', color: selectedCatId === category.id ? '#4338ca' : '#262626' }}>{category.name}</span>
//                           {/* className="text-[10px] tracking-wider text-neutral-400 font-mono uppercase" */}
//                           <span style={{ fontSize: '10px', letterSpacing: '0.05em', color: '#a3a3a3', fontFamily: 'monospace', textTransform: 'uppercase' }}>{category.id}</span>
//                         </div>
//                         {/* className="flex gap-1 shrink-0" */}
//                         <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
//                           {/* className="p-1.5 text-neutral-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-all" */}
//                           <button onClick={() => handleStartEditCategory(category.id, category.name)} style={{ padding: '6px', color: '#a3a3a3', backgroundColor: 'transparent', border: 'none', borderRadius: '8px', cursor: 'pointer' }}><Edit style={{ width: '16px', height: '16px' }} /></button>
//                           {/* className="p-1.5 text-neutral-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all" */}
//                           <button onClick={() => handleDeleteCategory(category.id)} style={{ padding: '6px', color: '#a3a3a3', backgroundColor: 'transparent', border: 'none', borderRadius: '8px', cursor: 'pointer' }}><Trash2 style={{ width: '16px', height: '16px' }} /></button>
//                         </div>
//                       </>
//                     )}
//                   </div>
//                 ))
//               )}
//             </div>

//             {/* Pagination Controls Footer */}
//             {categories.length > 0 && (
//               <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'space-between',
//                 padding: '10px 16px',
//                 backgroundColor: 'rgba(250, 250, 250, 0.8)',
//                 borderTop: '1px solid rgba(229, 229, 229, 0.6)',
//                 fontSize: '12px',
//                 color: '#737373',
//                 userSelect: 'none'
//               }}>
//                 <span>Page <b style={{ color: '#171717' }}>{catCurrentPage}</b> of {totalCatPages}</span>
//                 {/* className="flex gap-1" */}
//                 <div style={{ display: 'flex', gap: '4px' }}>
//                   <button 
//                     type="button"
//                     disabled={catCurrentPage === 1}
//                     onClick={() => setCatCurrentPage(p => Math.max(p - 1, 1))}
//                      style={{
//                       padding: '4px',
//                       backgroundColor: '#ffffff',
//                       border: '1px solid #e5e7eb',
//                       borderRadius: '8px',
//                       color: '#404040',
//                       cursor: catCurrentPage === 1 ? 'not-allowed' : 'pointer',
//                       opacity: catCurrentPage === 1 ? 0.4 : 1,
//                       display: 'flex'
//                     }}
//                   >
//                     <ChevronLeft style={{ width: '16px', height: '16px' }} />
//                   </button>
//                   <button 
//                     type="button"
//                     disabled={catCurrentPage === totalCatPages}
//                     onClick={() => setCatCurrentPage(p => Math.min(p + 1, totalCatPages))}
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#ffffff',
//                       border: '1px solid #e5e7eb',
//                       borderRadius: '8px',
//                       color: '#404040',
//                       cursor: catCurrentPage === totalCatPages ? 'not-allowed' : 'pointer',
//                       opacity: catCurrentPage === totalCatPages ? 0.4 : 1,
//                       display: 'flex'
//                     }}
//                   >
//                     <ChevronRight style={{ width: '16px', height: '16px' }} />
//                   </button>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//           <div style={{
//           backgroundColor: '#ffffff',
//           border: '1px solid rgba(229, 229, 229, 0.7)',
//           borderRadius: '16px',
//           padding: '24px',
//           boxShadow: '0 2px 8px -3px rgba(0,0,0,0.05)',
//           transition: 'all 0.3s'
//         }}>
//           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
//             <h2 style={{ fontSize: '18px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px', color: '#171717', margin: 0 }}>
//               <Layers style={{ width: '18px', height: '18px', color: '#7c3aed' }} /> Subcategory Mapping
//             </h2>
//             {selectedCatId && (
//               <span style={{
//                 fontSize: '11px',
//                 fontWeight: '500',
//                 backgroundColor: '#f5f3ff',
//                 border: '1px solid #ddd6fe',
//                 padding: '2px 8px',
//                 borderRadius: '9999px',
//                 color: '#7c3aed'
//               }}>
//                 {activeSubcategories.length} Children
//               </span>
//             )}
//           </div>

//           {/* Dropdown Selection */}
//           {/* className="space-y-1 mb-4" */}
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '16px' }}>
//             {/* className="block text-[11px] font-bold text-neutral-400 uppercase tracking-wider pl-0.5" */}
//             <label style={{ fontSize: '11px', fontWeight: '700', color: '#a3a3a3', textTransform: 'uppercase', letterSpacing: '0.05em', paddingLeft: '2px' }}>Bind to Parent Category</label>
//             {/* className="w-full px-3 py-2 bg-neutral-50 border border-neutral-200 rounded-xl text-sm font-medium text-neutral-800 outline-none focus:border-violet-500 focus:ring-4 focus:ring-violet-500/10 cursor-pointer transition-all" */}
//             <select 
//               value={selectedCatId}
//               onChange={(e) => { setSelectedCatId(e.target.value); setEditingSubId(null); setSubCurrentPage(1); }}
//               style={{
//                 width: '100%',
//                 padding: '8px 12px',
//                 backgroundColor: '#fafafa',
//                 border: '1px solid #e5e7eb',
//                 borderRadius: '12px',
//                 fontSize: '14px',
//                 fontWeight: '500',
//                 color: '#404040',
//                 outline: 'none',
//                 cursor: 'pointer'
//               }}
//             >
//               <option value="">-- Choose Category Container --</option>
//               {categories.map(cat => (
//                 <option key={cat.id} value={cat.id}>{cat.name}</option>
//               ))}
//             </select>
//           </div>

//           {selectedCatId ? (
//             /* className="space-y-4 animate-in fade-in duration-200" */
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              
//               {/* Input Action Form */}
//               {/* className="flex gap-2" */}
//               <form onSubmit={handleAddSubcategory} style={{ display: 'flex', gap: '8px' }}>
//                 {/* className="flex-1 px-3 py-2 bg-neutral-50 border border-neutral-200 rounded-xl outline-none text-sm text-neutral-900 placeholder:text-neutral-400 focus:border-violet-500 focus:bg-white focus:ring-4 focus:ring-violet-500/10 transition-all" */}
//                 <input 
//                   type="text"
//                   placeholder={`Add subcategory to "${activeCategory?.name}"...`}
//                   value={subcategoryInput}
//                   onChange={(e) => setSubcategoryInput(e.target.value)}
//                   style={{
//                     flex: 1,
//                     padding: '8px 12px',
//                     backgroundColor: '#fafafa',
//                     border: '1px solid #e5e7eb',
//                     borderRadius: '12px',
//                     outline: 'none',
//                     fontSize: '14px',
//                     color: '#171717',
//                     boxSizing: 'border-box'
//                   }}
//                 />
//                 {/* className="bg-violet-600 text-white px-4 py-2 rounded-xl text-sm font-medium hover:bg-violet-700 shadow-sm shadow-violet-500/20 active:scale-[0.98] transition-transform flex items-center gap-1 shrink-0" */}
//                 <button type="submit" style={{
//                   backgroundColor: '#7c3aed',
//                   color: '#ffffff',
//                   padding: '8px 16px',
//                   borderRadius: '12px',
//                   fontSize: '14px',
//                   fontWeight: '500',
//                   border: 'none',
//                   cursor: 'pointer',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '4px',
//                   flexShrink: 0
//                 }}>
//                   <Plus style={{ width: '16px', height: '16px' }} /> Sub
//                 </button>
//               </form>

//               {/* Subcategories Container */}
//               {/* className="border border-neutral-200/60 rounded-xl overflow-hidden bg-neutral-50/30" */}
//               <div style={{
//                 border: '1px solid rgba(229, 229, 229, 0.6)',
//                 borderRadius: '12px',
//                 overflow: 'hidden',
//                 backgroundColor: 'rgba(250, 250, 250, 0.3)'
//               }}>
//                 {/* className="divide-y divide-neutral-100 min-h-[180px] bg-white" */}
//                 <div style={{ minHeight: '180px', display: 'flex', flexDirection: 'column', backgroundColor: '#ffffff' }}>
//                   {displayedSubcategories.length === 0 ? (
//                     <div style={{ textAlign: 'center', padding: '64px 0', color: '#a3a3a3', fontSize: '14px', fontStyle: 'italic', flex: 1 }}>
//                       No children nodes mapped yet. Append one above.
//                     </div>
//                   ) : (
//                     displayedSubcategories.map(sub => (
//     <div key={sub.id} style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'space-between',
//                         padding: '12px',
//                         fontSize: '14px',
//                         backgroundColor: '#ffffff',
//                         borderBottom: '1px solid #f5f5f5'
//                       }}>
//                         {editingSubId === sub.id ? (
//                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1, marginRight: '8px' }}>
//                             <input 
//                               type="text"
//                               value={editValue}
//                               onChange={(e) => setEditValue(e.target.value)}
//                               style={{
//                                 flex: 1,
//                                 padding: '6px 10px',
//                                 border: '1px solid #7c3aed',
//                                 backgroundColor: '#ffffff',
//                                 borderRadius: '8px',
//                                 outline: 'none',
//                                 fontSize: '14px',
//                                 fontWeight: '500',
//                                 color: '#171717'
//                               }}
//                               autoFocus
//                             />
//                             <button onClick={() => handleSaveSubEdit(sub.id)} style={{ padding: '6px', backgroundColor: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0', borderRadius: '8px', cursor: 'pointer', display: 'flex' }}><Check style={{ width: '16px', height: '16px' }} /></button>
//                             <button onClick={() => setEditingSubId(null)} style={{ padding: '6px', backgroundColor: '#f5f5f5', color: '#737373', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', display: 'flex' }}><X style={{ width: '16px', height: '16px' }} /></button>
//                           </div>
//                         ) : (
//                           <>
//                             <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
//                               <span style={{ color: '#262626', fontWeight: '500', paddingLeft: '10px', borderLeft: '2px solid #7c3aed' }}>{sub.name}</span>
//                               <span style={{ fontSize: '9px', letterSpacing: '0.05em', color: '#a3a3a3', fontFamily: 'monospace', textTransform: 'uppercase', paddingLeft: '10px' }}>{sub.id}</span>
//                             </div>
//                             <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
//                                <button onClick={() => handleStartEditSub(sub.id, sub.name)} style={{ padding: '6px', color: '#a3a3a3', backgroundColor: 'transparent', border: 'none', borderRadius: '8px', cursor: 'pointer' }}><Edit style={{ width: '16px', height: '16px' }} /></button>
//                               <button onClick={() => handleDeleteSubcategory(sub.id)} style={{ padding: '6px', color: '#a3a3a3', backgroundColor: 'transparent', border: 'none', borderRadius: '8px', cursor: 'pointer' }}><Trash2 style={{ width: '16px', height: '16px' }} /></button>
//                             </div>
//                           </>
//                         )}
//                       </div>
//                     ))
//                   )}
//                 </div>

//                 {/* Subcategories Pagination Controls */}
//                 {activeSubcategories.length > 0 && (
//                   <div style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'space-between',
//                     padding: '10px 16px',
//                     backgroundColor: 'rgba(250, 250, 250, 0.8)',
//                     borderTop: '1px solid rgba(229, 229, 229, 0.6)',
//                     fontSize: '12px',
//                     color: '#737373',
//                     userSelect: 'none'
//                   }}>
//                     <span>Page <b style={{ color: '#171717' }}>{subCurrentPage}</b> of {totalSubPages}</span>
//                      <div style={{ display: 'flex', gap: '4px' }}>
//                       <button 
//                         type="button"
//                         disabled={subCurrentPage === 1}
//                         onClick={() => setSubCurrentPage(p => Math.max(p - 1, 1))}
//                          style={{
//                           padding: '4px',
//                           backgroundColor: '#ffffff',
//                           border: '1px solid #e5e7eb',
//                           borderRadius: '8px',
//                           color: '#404040',
//                           cursor: subCurrentPage === 1 ? 'not-allowed' : 'pointer',
//                           opacity: subCurrentPage === 1 ? 0.4 : 1,
//                           display: 'flex'
//                         }}
//                       >
//                         <ChevronLeft style={{ width: '16px', height: '16px' }} />
//                       </button>
//                       <button 
//                         type="button"
//                         disabled={subCurrentPage === totalSubPages}
//                         onClick={() => setSubCurrentPage(p => Math.min(p + 1, totalSubPages))}
//                         style={{
//                           padding: '4px',
//                           backgroundColor: '#ffffff',
//                           border: '1px solid #e5e7eb',
//                           borderRadius: '8px',
//                           color: '#404040',
//                           cursor: subCurrentPage === totalSubPages ? 'not-allowed' : 'pointer',
//                           opacity: subCurrentPage === totalSubPages ? 0.4 : 1,
//                           display: 'flex'
//                         }}
//                       >
//                         <ChevronRight style={{ width: '16px', height: '16px' }} />
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           ) : (
//              <div style={{
//               textAlign: 'center',
//               padding: '48px',
//               border: '2px dashed #e5e7eb',
//               borderRadius: '12px',
//               backgroundColor: 'rgba(250, 250, 250, 0.5)',
//               fontSize: '14px',
//               color: '#a3a3a3',
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               justifyContent: 'center',
//               gap: '8px'
//             }}>
//               <Layers style={{ width: '32px', height: '32px', color: '#d4d4d4' }} />
//               <span>Please pick a main category from the dropdown menu to configure its subcategory contents.</span>
//             </div>
//           )}
//         </div>

//       </div>
//     </div>
//   );
// }
// export default CategoryPage;